// Token-free diagnostics for the exact unpublished DEV test theme only.
const initCartDiagnostics = () => {
  const theme = window.Shopify?.theme
  if (String(theme?.id) !== '196356047183' || theme?.role !== 'unpublished' || window.Shopify?.designMode) return
  const panel = document.querySelector('[data-referral-status-panel]')
  if (!panel) return
  const write = (field, value) => {
    try {
      const target = panel.querySelector(`[data-cart-diagnostic="${field}"]`)
      if (target) target.textContent = value
    } catch (_) { /* Diagnostics must never interrupt cart behavior. */ }
  }
  const phases = new Set(['request', 'http', 'json', 'render', 'ready'])
  const removalPhases = new Set(['read', 'update', 'refresh', 'verify', 'ready', 'failed'])
  const reasons = new Set(['cart', 'quantity', 'gift-choice', 'gift-sync', 'discount-apply', 'discount-remove', 'product-add', 'protection', 'protection-cleanup', 'paid-gift', 'referral-refresh'])
  const errorNames = new Set(['TypeError', 'SyntaxError', 'RangeError', 'AbortError', 'TimeoutError'])
  window.AstariCartDiagnostics = {
    phase: value => { if (phases.has(value)) write('refresh', value) },
    failure: (phase, error, status) => {
      if (!phases.has(phase)) return
      const detail = phase === 'http' && Number.isInteger(status) && status >= 100 && status <= 599
        ? `HTTP ${status}` : errorNames.has(error?.name) ? error.name : 'Error'
      write('failure', `${phase}: ${detail}`)
    },
    busy: (active, referral) => {
      const labels = Array.from(active).filter(value => reasons.has(value))
      if (referral === true) labels.push('referral')
      write('busy', labels.join(', ') || 'None')
    },
    submit: blocked => write('submit', blocked === true ? 'Observed, blocked by pending work' : 'Observed, native submit allowed'),
    removal: value => { if (removalPhases.has(value)) write('removal', value) },
  }
}
initCartDiagnostics()

const howItWorksTimers = new WeakMap()
const howItWorksInterval = 8000
const isTouchLikePointer = () => window.matchMedia('(hover: none), (pointer: coarse)').matches
const inactiveTabTitles = {
  browsing: 'Still carrying cards around?',
  cart: 'You left something behind.'
}

let activeDocumentTitle = document.title
let inactiveTitleApplied = false

const getCartCountFromHeader = () => {
  const countElement = document.querySelector('[data-cart-count]')
  const count = Number.parseInt(countElement?.textContent || '0', 10)

  return Number.isFinite(count) ? count : 0
}

const syncInactiveTabTitle = () => {
  if (document.visibilityState === 'hidden') {
    if (!inactiveTitleApplied) activeDocumentTitle = document.title
    inactiveTitleApplied = true
    document.title = getCartCountFromHeader() > 0 ? inactiveTabTitles.cart : inactiveTabTitles.browsing
    return
  }

  if (inactiveTitleApplied) {
    document.title = activeDocumentTitle
    inactiveTitleApplied = false
  } else {
    activeDocumentTitle = document.title
  }
}

document.addEventListener('visibilitychange', syncInactiveTabTitle)

const setHowItWorksStep = (section, index) => {
  if (!section) return

  section.querySelectorAll('[data-how-step]').forEach((button) => {
    const active = button.dataset.howStep === String(index)
    button.classList.toggle('is-active', active)
    button.setAttribute('aria-selected', active ? 'true' : 'false')
  })

  section.querySelectorAll('[data-how-preview]').forEach((preview) => {
    preview.classList.toggle('is-active', preview.dataset.howPreview === String(index))
  })
}

const stopHowItWorksLoop = (section, paused = false) => {
  if (!section) return

  const timer = howItWorksTimers.get(section)
  if (timer) window.clearInterval(timer)
  howItWorksTimers.delete(section)
  section.dataset.howItWorksPaused = paused ? 'true' : 'false'
}

const advanceHowItWorksStep = (section) => {
  const steps = Array.from(section?.querySelectorAll('[data-how-step]') || [])
  if (steps.length < 2) return

  const currentIndex = Math.max(0, steps.findIndex((button) => button.classList.contains('is-active')))
  const nextIndex = Number.parseInt(steps[(currentIndex + 1) % steps.length].dataset.howStep || '0', 10)
  setHowItWorksStep(section, nextIndex)
}

const startHowItWorksLoop = (section) => {
  const steps = section?.querySelectorAll('[data-how-step]') || []
  if (!section || steps.length < 2 || howItWorksTimers.has(section)) return

  section.dataset.howItWorksPaused = 'false'
  howItWorksTimers.set(section, window.setInterval(() => {
    if (!section.isConnected) {
      stopHowItWorksLoop(section)
      return
    }

    advanceHowItWorksStep(section)
  }, howItWorksInterval))
}

const initHowItWorksLoops = (root = document) => {
  const sections = root.matches?.('[data-how-it-works]')
    ? [root]
    : Array.from(root.querySelectorAll('[data-how-it-works]'))

  sections.forEach((section) => {
    if (section.dataset.howItWorksPaused !== 'true') startHowItWorksLoop(section)
  })
}

const getRailSnapPositions = (rail) => {
  const railLeft = rail?.getBoundingClientRect().left || 0

  return Array.from(rail?.querySelectorAll(':scope > li') || [])
    .map((item) => item.getBoundingClientRect().left - railLeft + rail.scrollLeft)
    .filter((position) => Number.isFinite(position))
}

const scrollProductRailByCard = (rail, direction) => {
  const positions = getRailSnapPositions(rail)
  if (!rail || positions.length < 2) return

  const maxScrollLeft = rail.scrollWidth - rail.clientWidth
  const current = rail.scrollLeft
  const nearestIndex = positions.reduce((nearest, position, index) => {
    const nearestDistance = Math.abs(positions[nearest] - current)
    const distance = Math.abs(position - current)
    return distance < nearestDistance ? index : nearest
  }, 0)
  const targetIndex = Math.max(0, Math.min(positions.length - 1, nearestIndex + direction))
  const targetLeft = Math.max(0, Math.min(positions[targetIndex], maxScrollLeft))

  rail.scrollTo({ left: targetLeft, behavior: 'smooth' })
}

const showProductRailControls = (stage) => {
  if (!stage) return

  stage.classList.add('is-product-rail-moving')
  window.clearTimeout(stage.productRailControlsTimer)
  stage.productRailControlsTimer = window.setTimeout(() => {
    stage.classList.remove('is-product-rail-moving')
  }, 1000)
}

const getReviewSnapPositions = (viewport) => {
  const viewportLeft = viewport?.getBoundingClientRect().left || 0

  return Array.from(viewport?.querySelectorAll('.astari-review-card') || [])
    .map((card) => card.getBoundingClientRect().left - viewportLeft + viewport.scrollLeft)
    .filter((position) => Number.isFinite(position))
}

const snapReviewViewportToNearest = (viewport) => {
  const positions = getReviewSnapPositions(viewport)
  if (!viewport || positions.length < 2) return

  const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth
  const current = viewport.scrollLeft
  const nearestPosition = positions.reduce((nearest, position) => (
    Math.abs(position - current) < Math.abs(nearest - current) ? position : nearest
  ), positions[0])
  const targetLeft = Math.max(0, Math.min(nearestPosition, maxScrollLeft))

  viewport.scrollTo({ left: targetLeft, behavior: 'smooth' })
}

const showReviewRailControls = (stage) => {
  if (!stage) return

  stage.classList.add('is-review-moving')
  window.clearTimeout(stage.reviewControlsTimer)
  stage.reviewControlsTimer = window.setTimeout(() => {
    stage.classList.remove('is-review-moving')
  }, 1500)
}

const initReviewSwipeRails = (root = document) => {
  const rails = root.matches?.('[data-review-rail]')
    ? [root]
    : Array.from(root.querySelectorAll('[data-review-rail]'))

  rails.forEach((rail) => {
    const viewport = rail.closest('.astari-testimonials__viewport')
    const stage = viewport?.closest('.astari-testimonials__stage')
    if (!viewport || viewport.dataset.reviewSwipeReady === 'true') return

    viewport.dataset.reviewSwipeReady = 'true'

    let activePointer = null
    let startX = 0
    let startY = 0
    let startScrollLeft = 0
    let isDragging = false
    let isCancelled = false
    let mouseActive = false

    const canSwipe = () => (
      window.matchMedia('(max-width: 760px)').matches &&
      viewport.scrollWidth > viewport.clientWidth + 2
    )

    const resetSwipe = () => {
      activePointer = null
      isDragging = false
      isCancelled = false
    }

    const beginSwipe = (clientX, clientY) => {
      startX = clientX
      startY = clientY
      startScrollLeft = viewport.scrollLeft
      isDragging = false
      isCancelled = false
    }

    const moveSwipe = (clientX, clientY, event) => {
      if (isCancelled) return

      const deltaX = clientX - startX
      const deltaY = clientY - startY
      const horizontalIntent = Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15
      const verticalIntent = Math.abs(deltaY) > 8 && Math.abs(deltaY) > Math.abs(deltaX)

      if (!isDragging && verticalIntent) {
        isCancelled = true
        return
      }

      if (!isDragging && !horizontalIntent) return

      isDragging = true
      showReviewRailControls(stage)
      event.preventDefault()
      viewport.scrollLeft = startScrollLeft - deltaX
    }

    const endSwipe = () => {
      if (isDragging) snapReviewViewportToNearest(viewport)
      resetSwipe()
    }

    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse') return
      if (event.button !== undefined && event.button !== 0) return
      if (!canSwipe()) return

      activePointer = event.pointerId
      beginSwipe(event.clientX, event.clientY)
      viewport.setPointerCapture?.(event.pointerId)
    }, { passive: true })

    viewport.addEventListener('pointermove', (event) => {
      if (activePointer !== event.pointerId || isCancelled) return
      moveSwipe(event.clientX, event.clientY, event)
    }, { passive: false })

    viewport.addEventListener('pointerup', (event) => {
      if (activePointer !== event.pointerId) return
      endSwipe()
    }, { passive: true })

    viewport.addEventListener('pointercancel', resetSwipe, { passive: true })
    viewport.addEventListener('lostpointercapture', resetSwipe, { passive: true })

    viewport.addEventListener('scroll', () => {
      showReviewRailControls(stage)
    }, { passive: true })

    viewport.addEventListener('mousedown', (event) => {
      if (event.button !== 0 || !canSwipe()) return

      mouseActive = true
      beginSwipe(event.clientX, event.clientY)
    }, { passive: true })

    window.addEventListener('mousemove', (event) => {
      if (!mouseActive) return
      moveSwipe(event.clientX, event.clientY, event)
    }, { passive: false })

    window.addEventListener('mouseup', () => {
      if (!mouseActive) return

      mouseActive = false
      endSwipe()
    }, { passive: true })
  })
}

document.addEventListener('click', (event) => {
  if (!window.matchMedia('(max-width: 989px)').matches) return
  if (event.target.closest('a, button, input, select, textarea')) return

  const card = event.target.closest('[data-ring-tier-card-link]')
  const url = card?.dataset.ringTierCardLink
  if (!url) return

  window.location.href = url
})

document.addEventListener('click', (event) => {
  const revealButton = event.target.closest('[data-product-card-reveal]')
  const closeButton = event.target.closest('[data-product-card-close]')
  const previousRailButton = event.target.closest('[data-product-rail-prev]')
  const nextRailButton = event.target.closest('[data-product-rail-next]')
  const previousReviewButton = event.target.closest('[data-review-rail-prev]')
  const nextReviewButton = event.target.closest('[data-review-rail-next]')
  const howStep = event.target.closest('[data-how-step]')
  const communityCard = event.target.closest('[data-community-card]')
  const productFactTip = event.target.closest('[data-product-fact-tip]')

  if (revealButton) {
    const card = revealButton.closest('[data-product-card]')
    card?.classList.add('is-revealed')
    card?.querySelector('.astari-product-card__overlay')?.setAttribute('aria-hidden', 'false')
  }

  if (closeButton) {
    const card = closeButton.closest('[data-product-card]')
    card?.classList.remove('is-revealed')
    card?.querySelector('.astari-product-card__overlay')?.setAttribute('aria-hidden', 'true')
  }

  if (previousRailButton || nextRailButton) {
    const stage = event.target.closest('.astari-product-collection__stage')
    const rail = stage?.querySelector('[data-product-rail]')

    showProductRailControls(stage)
    scrollProductRailByCard(rail, nextRailButton ? 1 : -1)
  }

  if (previousReviewButton || nextReviewButton) {
    const stage = event.target.closest('.astari-testimonials__stage')
    const rail = stage?.querySelector('[data-review-rail]')
    const firstCard = rail?.querySelector('article')

    if (!rail || !firstCard) return

    showReviewRailControls(stage)
    const gap = Number.parseFloat(window.getComputedStyle(rail).columnGap || '0')
    const distance = firstCard.getBoundingClientRect().width + gap
    rail.parentElement.scrollBy({ left: (nextReviewButton ? 1 : -1) * distance, behavior: 'smooth' })
  }

  if (howStep) {
    const section = howStep.closest('[data-how-it-works]')
    const index = howStep.dataset.howStep

    stopHowItWorksLoop(section, true)
    setHowItWorksStep(section, index)
  }

  if (communityCard && !event.target.closest('a')) {
    if (isTouchLikePointer()) {
      communityCard.parentElement?.querySelectorAll('[data-community-card]').forEach((card) => {
        card.classList.toggle('is-active', card === communityCard)
      })
    }
  }

  if (productFactTip && isTouchLikePointer()) {
    const wasActive = productFactTip.classList.contains('is-active')

    productFactTip.parentElement?.querySelectorAll('[data-product-fact-tip]').forEach((tip) => {
      const active = tip === productFactTip && !wasActive
      tip.classList.toggle('is-active', active)
      tip.setAttribute('aria-expanded', active ? 'true' : 'false')
    })
  } else if (isTouchLikePointer()) {
    document.querySelectorAll('[data-product-fact-tip].is-active').forEach((tip) => {
      tip.classList.remove('is-active')
      tip.setAttribute('aria-expanded', 'false')
    })
  }
})

document.addEventListener('keydown', (event) => {
  const communityCard = event.target.closest?.('[data-community-card]')
  const productFactTip = event.target.closest?.('[data-product-fact-tip]')

  if (productFactTip && isTouchLikePointer() && (event.key === 'Enter' || event.key === ' ')) {
    event.preventDefault()
    const wasActive = productFactTip.classList.contains('is-active')

    productFactTip.parentElement?.querySelectorAll('[data-product-fact-tip]').forEach((tip) => {
      const active = tip === productFactTip && !wasActive
      tip.classList.toggle('is-active', active)
      tip.setAttribute('aria-expanded', active ? 'true' : 'false')
    })
    return
  }

  if (!communityCard || (event.key !== 'Enter' && event.key !== ' ')) return

  event.preventDefault()
  communityCard.parentElement?.querySelectorAll('[data-community-card]').forEach((card) => {
    card.classList.toggle('is-active', card === communityCard)
  })
})

document.addEventListener('focusout', (event) => {
  const card = event.target.closest?.('[data-product-card]')

  if (!card) return

  window.setTimeout(() => {
    if (!card.contains(document.activeElement)) {
      card.classList.remove('is-revealed')
      card.querySelector('.astari-product-card__overlay')?.setAttribute('aria-hidden', 'true')
    }
  }, 0)
})

const loadLazyVideo = (video) => {
  if (!video || video.dataset.lazyVideoLoaded === 'true') return

  if (video.dataset.poster && !video.poster) {
    video.poster = video.dataset.poster
  }

  const sources = Array.from(video.querySelectorAll('source[data-src]'))
  if (sources.length) {
    const maxWidth = video.matches('[data-product-card-video]') ? 480 : 720
    const targetWidth = Math.min(maxWidth, Math.ceil(video.getBoundingClientRect().width * (window.devicePixelRatio || 1)))
    const ranked = sources.filter((source) => source.type === 'video/mp4' && Number(source.dataset.videoWidth) > 0)
      .sort((a, b) => Number(a.dataset.videoWidth) - Number(b.dataset.videoWidth))
    const selected = ranked.find((source) => Number(source.dataset.videoWidth) >= targetWidth) || ranked[ranked.length - 1] || sources[0]
    sources.forEach((source) => {
      if (source === selected) {
        source.src = source.dataset.src
        source.removeAttribute('data-src')
      } else {
        source.remove()
      }
    })
    video.preload = 'auto'
  }
  video.dataset.lazyVideoLoaded = 'true'
  video.load()
}

const playLazyVideo = (video) => {
  if (!video || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

  loadLazyVideo(video)
  const playPromise = video.play()
  if (playPromise?.catch) {
    playPromise.catch(() => {})
  }
}

const pauseLazyVideo = (video) => {
  if (!video || typeof video.pause !== 'function') return
  video.pause()
}

const initVideoPrewarming = () => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
  const videos = document.querySelectorAll('[data-product-gallery-video]')
  if (!('IntersectionObserver' in window)) return
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return
      loadLazyVideo(entry.target)
      observer.unobserve(entry.target)
    })
  }, { rootMargin: '200px 0px', threshold: 0.01 })
  videos.forEach((video) => observer.observe(video))
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const nextVideo = Array.from(gallery.querySelectorAll('[data-product-gallery-video]'))
      .find((video) => video.getBoundingClientRect().width > 0)
    if (nextVideo) loadLazyVideo(nextVideo)
  })
}

if (document.readyState === 'complete') {
  window.setTimeout(initVideoPrewarming, 1000)
} else {
  window.addEventListener('load', () => window.setTimeout(initVideoPrewarming, 1000), { once: true })
}

const initAstariAutoplayVideos = (root = document) => {
  const videos = root.matches?.('[data-astari-autoplay-video]')
    ? [root]
    : Array.from(root.querySelectorAll('[data-astari-autoplay-video]'))

  videos.forEach((video) => {
    if (video.dataset.astariAutoplayVideoReady === 'true') return
    video.dataset.astariAutoplayVideoReady = 'true'

    if (video.dataset.poster && !video.poster) video.poster = video.dataset.poster
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    if (!('IntersectionObserver' in window)) {
      playLazyVideo(video)
      return
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          playLazyVideo(video)
        } else {
          pauseLazyVideo(video)
        }
      })
    }, { rootMargin: '200px 0px', threshold: 0.25 })

    observer.observe(video)
  })
}

document.addEventListener('mouseover', (event) => {
  const card = event.target.closest?.('[data-product-card]')
  if (!card || card.contains(event.relatedTarget)) return

  playLazyVideo(card.querySelector('[data-product-card-video]'))
})

document.addEventListener('pointerover', (event) => {
  const card = event.target.closest?.('[data-product-card]')
  if (!card || card.contains(event.relatedTarget)) return

  playLazyVideo(card.querySelector('[data-product-card-video]'))
})

document.addEventListener('mouseout', (event) => {
  const card = event.target.closest?.('[data-product-card]')
  if (!card || card.contains(event.relatedTarget)) return

  pauseLazyVideo(card.querySelector('[data-product-card-video]'))
})

document.addEventListener('pointerout', (event) => {
  const card = event.target.closest?.('[data-product-card]')
  if (!card || card.contains(event.relatedTarget)) return

  pauseLazyVideo(card.querySelector('[data-product-card-video]'))
})

document.addEventListener('focusin', (event) => {
  const card = event.target.closest?.('[data-product-card]')
  if (!card) return

  playLazyVideo(card.querySelector('[data-product-card-video]'))
})

document.addEventListener('focusout', (event) => {
  const card = event.target.closest?.('[data-product-card]')
  if (!card) return

  window.setTimeout(() => {
    if (!card.contains(document.activeElement)) {
      pauseLazyVideo(card.querySelector('[data-product-card-video]'))
    }
  }, 0)
})

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initHowItWorksLoops()
    initReviewSwipeRails()
    initAstariAutoplayVideos()
  })
} else {
  initHowItWorksLoops()
  initReviewSwipeRails()
  initAstariAutoplayVideos()
}
document.addEventListener('shopify:section:load', (event) => initHowItWorksLoops(event.target))
document.addEventListener('shopify:section:load', (event) => initReviewSwipeRails(event.target))
document.addEventListener('shopify:section:load', (event) => initAstariAutoplayVideos(event.target))
window.addEventListener('scroll', () => {
  document.querySelectorAll('[data-how-it-works][data-how-it-works-paused="true"]').forEach((section) => {
    startHowItWorksLoop(section)
  })
}, { passive: true })
window.addEventListener('pagehide', () => {
  document.querySelectorAll('[data-how-it-works]').forEach((section) => stopHowItWorksLoop(section))
})

;(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  if (reducedMotion) return

  document.querySelectorAll('[data-trust-rail]').forEach((rail) => {
    const cards = Array.from(rail.children)
    if (cards.length < 2) return

    let userInteracted = false

    const scrollNext = () => {
      if (userInteracted || !rail.isConnected) return

      const gap = Number.parseFloat(window.getComputedStyle(rail).columnGap || '0')
      const cardWidth = cards[0]?.getBoundingClientRect().width || 0
      const distance = cardWidth + gap
      const nextLeft = rail.scrollLeft + distance
      const maxLeft = rail.scrollWidth - rail.clientWidth - 2

      rail.scrollTo({
        left: nextLeft >= maxLeft ? 0 : nextLeft,
        behavior: 'smooth',
      })
    }

    const interval = window.setInterval(scrollNext, 8000)
    rail.addEventListener('pointerdown', () => { userInteracted = true }, { passive: true })
    rail.addEventListener('focusin', () => { userInteracted = true })
    rail.addEventListener('mouseenter', () => { userInteracted = true })
    window.addEventListener('pagehide', () => window.clearInterval(interval), { once: true })
  })
})()

const initSingleAccordions = (root = document) => {
  const accordions = root.matches?.('[data-single-accordion]')
    ? [root]
    : Array.from(root.querySelectorAll('[data-single-accordion]'))

  accordions.forEach((accordion) => {
    if (accordion.dataset.singleAccordionReady === 'true') return

    accordion.dataset.singleAccordionReady = 'true'
    const detailsSelector = accordion.dataset.accordionItems === 'all' ? 'details' : ':scope > details'
    const details = Array.from(accordion.querySelectorAll(detailsSelector))
    const startClosed = accordion.hasAttribute('data-accordion-start-closed')
    let activeDetail = details.find((detail) => detail.open) || (startClosed ? null : details[0])

    const panelFor = (detail) => detail.querySelector(':scope > div')
    const panelAnimations = new WeakMap()
    const shouldScrollOpenDetail = !accordion.hasAttribute('data-accordion-scroll-disabled')
    const accordionScrollMedia = window.matchMedia('(max-width: 1023px)')
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const fallbackDuration = 320

    const scrollDetailIntoView = (detail) => {
      if (!detail.open) return

      if (!shouldScrollOpenDetail) return
      if (!accordionScrollMedia.matches) return

      const header = document.querySelector('.astari-header')
      const headerHeight = header?.getBoundingClientRect().height || 0
      const topOffset = headerHeight + 16
      const targetTop = detail.getBoundingClientRect().top + window.scrollY - topOffset

      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      })
    }

    const clearPanelAnimation = (panel) => {
      const animation = panelAnimations.get(panel)
      if (!animation) return

      panel.removeEventListener('transitionend', animation.onEnd)
      window.clearTimeout(animation.timeout)
      panelAnimations.delete(panel)
    }

    const finishPanelAnimation = (detail, panel, open, afterFinish) => {
      clearPanelAnimation(panel)

      if (open) {
        panel.style.height = 'auto'
        panel.style.opacity = '1'
      } else {
        detail.open = false
        panel.style.height = '0px'
        panel.style.opacity = '0'
      }

      afterFinish?.()
    }

    const animatePanel = (detail, panel, open, afterFinish) => {
      clearPanelAnimation(panel)

      if (prefersReducedMotion) {
        finishPanelAnimation(detail, panel, open, afterFinish)
        return
      }

      const onEnd = (event) => {
        if (event.target !== panel || event.propertyName !== 'height') return
        finishPanelAnimation(detail, panel, open, afterFinish)
      }
      const timeout = window.setTimeout(() => {
        finishPanelAnimation(detail, panel, open, afterFinish)
      }, fallbackDuration)

      panelAnimations.set(panel, { onEnd, timeout })
      panel.addEventListener('transitionend', onEnd)
    }

    details.forEach((detail) => {
      const panel = panelFor(detail)
      if (!panel) return

      if (detail === activeDetail) {
        detail.open = true
        panel.style.height = 'auto'
        panel.style.opacity = '1'
      } else {
        detail.open = false
        panel.style.height = '0px'
        panel.style.opacity = '0'
      }
    })

    const closeDetail = (detail) => {
      const panel = panelFor(detail)
      if (!panel || !detail.open) return
      if (activeDetail === detail) activeDetail = null

      panel.style.height = `${panel.getBoundingClientRect().height || panel.scrollHeight}px`
      panel.style.opacity = '1'

      window.requestAnimationFrame(() => {
        panel.style.height = '0px'
        panel.style.opacity = '0'
      })

      animatePanel(detail, panel, false)
    }

    const openDetail = (detail) => {
      const panel = panelFor(detail)
      if (!panel) return

      details.forEach((otherDetail) => {
        if (otherDetail !== detail) closeDetail(otherDetail)
      })

      activeDetail = detail
      detail.open = true
      panel.style.height = `${panel.getBoundingClientRect().height || 0}px`
      panel.style.opacity = '0'

      window.requestAnimationFrame(() => {
        panel.style.height = `${panel.scrollHeight}px`
        panel.style.opacity = '1'
      })

      animatePanel(detail, panel, true, () => {
        scrollDetailIntoView(detail)
      })
    }

    accordion.addEventListener('click', (event) => {
      const summary = event.target.closest('summary')
      if (!summary || !accordion.contains(summary)) return

      event.preventDefault()
      const detail = summary.closest('details')
      if (!detail) return

      if (detail.open) {
        closeDetail(detail)
      } else {
        openDetail(detail)
      }
    })
  })
}

initSingleAccordions()
document.addEventListener('shopify:section:load', (event) => initSingleAccordions(event.target))

;(() => {
  const drawer = document.querySelector('[data-cart-drawer]')
  if (!drawer) return

  // Follow the actual flex wrap, including longer translated cart titles.
  const headingRow = drawer.querySelector('.astari-cart-drawer__heading-row')
  const headingTitle = headingRow?.querySelector('h2')
  const headingRating = headingRow?.querySelector('.astari-cart-drawer__rating')
  if (headingRow && headingTitle && headingRating && 'ResizeObserver' in window) {
    const syncHeaderWrap = () => {
      const titleBounds = headingTitle.getBoundingClientRect()
      const ratingBounds = headingRating.getBoundingClientRect()
      headingRow.classList.toggle('is-wrapped', ratingBounds.top >= titleBounds.bottom - 1)
    }
    const headerResizeObserver = new ResizeObserver(syncHeaderWrap)
    ;[headingRow, headingTitle, headingRating].forEach((element) => headerResizeObserver.observe(element))
    document.fonts?.ready.then(syncHeaderWrap)
  }

  const root = drawer.dataset.cartRoot || '/'
  const itemsContainer = drawer.querySelector('[data-cart-items]')
  const filledContent = drawer.querySelector('[data-cart-filled]')
  const footer = drawer.querySelector('[data-cart-footer]')
  const total = drawer.querySelector('[data-cart-total]')
  const titleCount = drawer.querySelector('[data-cart-title-count]')
  const status = drawer.querySelector('[data-cart-status]')
  const cartNotice = drawer.querySelector('[data-cart-notice]')
  const cartTimer = drawer.querySelector('[data-cart-timer]')
  const body = drawer.querySelector('.astari-cart-drawer__body')
  const services = drawer.querySelector('.astari-cart-services')
  const shippingProtection = drawer.querySelector('[data-cart-protection]')
  const shippingProtectionToggle = drawer.querySelector('[data-cart-protection-toggle]')
  const shippingProtectionStatus = drawer.querySelector('[data-cart-protection-status]')
  const shippingProtectionPrice = drawer.querySelector('[data-cart-protection-price]')
  const upsell = drawer.querySelector('[data-cart-upsell]')
  const upsellEyebrow = drawer.querySelector('[data-cart-upsell-eyebrow]')
  const upsellHeading = drawer.querySelector('[data-cart-upsell-heading]')
  const upsellBadge = drawer.querySelector('[data-cart-upsell-badge]')
  const upsellText = drawer.querySelector('[data-cart-upsell-text]')
  const upsellProgress = drawer.querySelector('[data-cart-upsell-progress]')
  const giftRestore = drawer.querySelector('[data-cart-restore-gift]')
  const discountSummary = drawer.querySelector('[data-cart-discounts]')
  const originalTotal = drawer.querySelector('[data-cart-original-total]')
  const discountForm = drawer.querySelector('[data-cart-discount-form]')
  const discountInput = discountForm?.querySelector('input')
  const discountFeedback = drawer.querySelector('[data-cart-discount-feedback]')
  const checkoutDiscountInput = drawer.querySelector('[data-cart-checkout-discount]')
  let applyingDiscount = false
  const giftChoiceEnabled = drawer.dataset.cartGiftChoiceEnabled === 'true'
  const giftOptOutAttribute = '_astari_free_gift_opt_out'
  const acceleratedCheckout = drawer.querySelector('.astari-cart-accelerated-checkout shopify-accelerated-checkout-cart')
  const emptyHTML = itemsContainer?.innerHTML || ''
  const freeGiftThreshold = Number(drawer.dataset.cartFreeGiftThreshold || 17500)
  const freeGiftEligibleHandles = new Set((drawer.dataset.cartGiftEligibleHandles || '').split(',').filter(Boolean))
  const freeGiftVariantId = drawer.dataset.cartFreeGiftVariant || ''
  const giftMarketPrices = new Map()
  const giftMarketRequests = new Set()
  let latestUpsellCart = null
  const shippingProtectionVariantId = drawer.dataset.cartShippingProtectionVariant || ''
  const shippingProtectionProductId = drawer.dataset.cartShippingProtectionProduct || ''
  const shippingProtectionBasePrice = Number(drawer.dataset.cartShippingProtectionPrice || 0)
  const interpolateLabel = (template, replacements = {}) =>
    Object.entries(replacements).reduce((label, [key, value]) => {
      return label.replaceAll(`__${key}__`, String(value))
    }, template || '')
  let cartViewportFrame = null
  const syncCartViewportHeight = () => {
    cartViewportFrame = null
    const viewport = window.visualViewport
    const viewportHeight = viewport?.height || window.innerHeight
    drawer.style.setProperty('--astari-cart-viewport-top', `${Math.round(viewport?.offsetTop || 0)}px`)
    drawer.classList.toggle('is-keyboard-open', window.innerWidth <= 760 && window.innerHeight - viewportHeight > 120)
    if (viewportHeight) {
      drawer.style.setProperty('--astari-cart-viewport-height', `${Math.round(viewportHeight)}px`)
    }
  }
  const requestCartViewportHeightSync = () => {
    if (drawer.hidden) return
    if (cartViewportFrame) return
    cartViewportFrame = window.requestAnimationFrame(syncCartViewportHeight)
  }
  const cartLabels = {
    cartCount: drawer.dataset.cartLabelCartCount || 'Cart: __COUNT__',
    defaultProduct: drawer.dataset.cartLabelDefaultProduct || 'Astari wearable',
    shippingProtectionTitle: drawer.dataset.cartLabelShippingProtectionTitle || 'Shipping Protection',
    shippingProtectionOn: drawer.dataset.cartLabelShippingProtectionOn || 'On',
    shippingProtectionOff: drawer.dataset.cartLabelShippingProtectionOff || 'Off',
    freeGift: drawer.dataset.cartLabelFreeGift || 'Free gift',
    worth: drawer.dataset.cartLabelWorth || 'Worth __AMOUNT__',
    freeGiftUnlocked: drawer.dataset.cartLabelFreeGiftUnlocked || 'Free gift unlocked',
    addMore: drawer.dataset.cartLabelAddMore || 'Add __AMOUNT__ more',
    freeProductIncluded: drawer.dataset.cartLabelFreeProductIncluded || 'Your free __PRODUCT__ is included.',
    getFreeProduct: drawer.dataset.cartLabelGetFreeProduct || 'Get a free __PRODUCT__.',
    quantityFor: drawer.dataset.cartLabelQuantityFor || 'Quantity for __TITLE__',
    decreaseQuantity: drawer.dataset.cartLabelDecreaseQuantity || 'Decrease quantity',
    increaseQuantity: drawer.dataset.cartLabelIncreaseQuantity || 'Increase quantity',
    giftRemoved: drawer.dataset.cartLabelGiftRemoved || 'Free gift removed',
    giftRemovedNote: drawer.dataset.cartLabelGiftRemovedNote || 'Your discount code will be checked without the free gift.',
    giftConflict: drawer.dataset.cartLabelGiftConflict || 'Discount code unavailable',
    giftConflictNote: drawer.dataset.cartLabelGiftConflictNote || 'Free gifts and discount codes cannot be combined. Remove the gift with × to try your code instead.',
    removeGift: drawer.dataset.cartLabelRemoveGift || 'Remove free gift and try discount code',
    discount: drawer.dataset.cartLabelDiscount || 'Discount',
    removeDiscount: drawer.dataset.cartLabelRemoveDiscount || 'Remove discount code __CODE__',
    discountApplied: drawer.dataset.cartLabelDiscountApplied || 'Discount applied.',
    discountInvalid: drawer.dataset.cartLabelDiscountInvalid || 'This code cannot be applied to your cart.',
  }
  const cartStatusLabels = {
    couldNotLoad: drawer.dataset.cartStatusCouldNotLoad || 'Could not load cart',
    couldNotRefresh: drawer.dataset.cartStatusCouldNotRefresh || 'We could not refresh your cart. Please try again in a moment.',
    couldNotAddShippingProtection: drawer.dataset.cartStatusCouldNotAddShippingProtection || 'Could not add shipping protection',
    couldNotUpdateShippingProtection: drawer.dataset.cartStatusCouldNotUpdateShippingProtection || 'Could not update shipping protection.',
    couldNotUpdateItem: drawer.dataset.cartStatusCouldNotUpdateItem || 'Could not update that item. Please try again.',
    couldNotUpdateCart: drawer.dataset.cartStatusCouldNotUpdateCart || 'Could not update cart',
    couldNotAddProduct: drawer.dataset.cartStatusCouldNotAddProduct || 'Could not add product to cart',
    couldNotAddProductPeriod: drawer.dataset.cartStatusCouldNotAddProductPeriod || 'Could not add product to cart.',
    updatingCart: drawer.dataset.cartStatusUpdatingCart || 'Updating cart...',
    addingShippingProtection: drawer.dataset.cartStatusAddingShippingProtection || 'Adding shipping protection...',
    removingShippingProtection: drawer.dataset.cartStatusRemovingShippingProtection || 'Removing shipping protection...',
    addingToCart: drawer.dataset.cartStatusAddingToCart || 'Adding to cart...',
    addedToCart: drawer.dataset.cartStatusAddedToCart || 'Added to cart.',
    addedToCartProtectionFailed: drawer.dataset.cartStatusAddedToCartProtectionFailed || 'Added to cart. Shipping protection could not be added automatically.',
  }
  let activeCart = null
  let cleaningShippingProtection = false
  let addingShippingProtection = false
  let syncingFreeGift = false
  let updatingGiftChoice = false
  let changingCartQuantity = false
  let addingProduct = false
  let hasRenderedCart = false





  let acceleratedCheckoutSyncTimer = null
  let syncingAcceleratedCheckout = false

  const route = (path) => `${root.replace(/\/$/, '')}/${path.replace(/^\//, '')}`

  const escapeHTML = (value = '') =>
    String(value).replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[character])

  const formatMoney = (amount, currency = 'EUR') => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
      }).format(amount / 100)
    } catch (_error) {
      return `${(amount / 100).toFixed(2)} ${currency}`
    }
  }

  const formatMoneyWhole = (amount, currency = 'EUR') => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
        maximumFractionDigits: 0,
      }).format(amount / 100)
    } catch (_error) {
      return `${Math.round(amount / 100)} ${currency}`
    }
  }

  const formatMoneyWithoutCurrency = (amount) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount / 100)
    } catch (_error) {
      return (amount / 100).toFixed(2)
    }
  }

  const cartCurrency = (cart) => cart?.currency || window.Shopify?.currency?.active || 'EUR'

  const roundedCurrencyThreshold = (baseThreshold) => {
    const currencyRate = Number(window.Shopify?.currency?.rate || 1)
    if (!Number.isFinite(currencyRate) || currencyRate <= 0 || currencyRate === 1) return baseThreshold

    const convertedMajor = (baseThreshold / 100) * currencyRate
    const roundedMajor = Math.max(1, Math.floor(convertedMajor / 5) * 5)
    return Math.round(roundedMajor * 100)
  }

  let cartTimerDeadline = 0
  let cartTimerStorageKey = ''
  let cartTimerHasItems = false
  let cartTimerInterval = null
  const cartTimerDuration = Math.min(30, Math.max(1, Number(cartTimer?.dataset.durationMinutes) || 10)) * 60000

  const updateCartNotice = () => {
    const hasError = Boolean(status && !status.hidden && status.classList.contains('is-error'))
    const showTimer = Boolean(cartTimer && cartTimerHasItems && cartTimerDeadline > 0 && !hasError)
    if (cartNotice) cartNotice.hidden = !hasError && !showTimer
    if (!cartTimer) return
    cartTimer.hidden = !showTimer
    const seconds = Math.max(0, Math.ceil((cartTimerDeadline - Date.now()) / 1000))
    const value = cartTimer.querySelector('[data-cart-timer-value]')
    if (value) value.textContent = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`
    const running = cartTimer.querySelector('[data-cart-timer-running]')
    const finished = cartTimer.querySelector('[data-cart-timer-finished]')
    cartTimer.classList.toggle('is-expired', seconds === 0)
    if (running) running.hidden = seconds === 0
    if (finished) finished.hidden = seconds > 0
  }

  const syncCartTimer = (cart, count) => {
    if (!cartTimer) return
    const key = `astari:checkout-timer:v1:${String(cart.token || 'current').split('?')[0]}`
    const prefix = cartTimer.querySelector('[data-cart-timer-prefix]')
    if (prefix) prefix.textContent = count === 1 ? prefix.dataset.singular : prefix.dataset.plural
    cartTimerHasItems = count > 0
    if (!cartTimerHasItems) {
      try { window.sessionStorage.removeItem(cartTimerStorageKey || key) } catch (_) {}
      cartTimerDeadline = 0
      cartTimerStorageKey = ''
    } else if (!cartTimerDeadline || key !== cartTimerStorageKey) {
      cartTimerStorageKey = key
      let saved = 0
      try { saved = Number(window.sessionStorage.getItem(key)) } catch (_) {}
      cartTimerDeadline = Number.isFinite(saved) && saved > 0 && saved <= Date.now() + cartTimerDuration
        ? saved : Date.now() + cartTimerDuration
      try { window.sessionStorage.setItem(key, String(cartTimerDeadline)) } catch (_) {}
    }
    updateCartNotice()
    if (cartTimerInterval) window.clearInterval(cartTimerInterval)
    cartTimerInterval = null
    if (cartTimerHasItems && drawer.classList.contains('is-open')) {
      cartTimerInterval = window.setInterval(updateCartNotice, 1000)
    }
  }

  const setStatus = (message, error = false) => {
    if (!status) return
    status.textContent = error ? message || '' : ''
    status.hidden = !error || !message
    status.classList.toggle('is-error', error && Boolean(message))
    updateCartNotice()
  }

  document.addEventListener('visibilitychange', updateCartNotice)

  const updateCounts = (count) => {
    if (titleCount) titleCount.textContent = String(count)

    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      element.textContent = String(count)
      element.hidden = count === 0
    })

    document.querySelectorAll('[data-cart-mobile-count]').forEach((element) => {
      element.textContent = count > 0 ? `(${count})` : ''
    })

    document.querySelectorAll('[data-cart-open]').forEach((element) => {
      element.setAttribute('aria-label', interpolateLabel(cartLabels.cartCount, { COUNT: count }))
    })
  }

  const shortProductTitle = (item) => {
    const title = item.product_title || item.title || cartLabels.defaultProduct
    const pipeParts = title.split('|').map((part) => part.trim())

    if (pipeParts.length > 1 && /^Atlantis$/i.test(pipeParts[1])) {
      const material = pipeParts[0]
        .replace(/^Contactless Payment\s+/i, '')
        .replace(/^Ring\s+/i, '')
        .trim()

      return `Atlantis ${material}`.trim()
    }

    if (pipeParts.length > 1) {
      const type = pipeParts[0].match(/Ring|Bracelet|Keychain|Gift Box/i)?.[0] || ''
      return `${pipeParts[1]} ${type}`.trim()
    }

    return title
      .replace(/^Contactless Payment\s+/i, '')
      .replace(/\s*\|\s*Atlantis\s*$/i, '')
      .replace(/\s*-\s*Default Title\s*$/i, '')
      .trim()
  }

  const isShippingProtectionItem = (item) => {
    if (!item) return false

    const variantMatch = shippingProtectionVariantId && String(item.variant_id) === String(shippingProtectionVariantId)
    const productMatch = shippingProtectionProductId && String(item.product_id) === String(shippingProtectionProductId)
    const handleMatch = /\/products\/shipping-protection(?:[/?#]|$)/i.test(item.url || '')
    const titlePattern = new RegExp(`^${cartLabels.shippingProtectionTitle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}$`, 'i')
    const titleMatch = titlePattern.test(item.product_title || item.title || '')

    return variantMatch || productMatch || handleMatch || titleMatch
  }

  const isFreeGiftItem = (item) => {
    if (!item || !freeGiftVariantId || String(item.variant_id) !== String(freeGiftVariantId)) return false

    return item.properties?._astari_free_gift === 'true'
  }

  const isPaidFreeGiftVariantItem = (item) => (
    Boolean(item)
    && Boolean(freeGiftVariantId)
    && String(item.variant_id) === String(freeGiftVariantId)
    && !isFreeGiftItem(item)
    && item.properties?._astari_keychain_bundle !== 'true'
  )

  const visibleCartItems = (cart) => (cart?.items || []).filter((item) => !isShippingProtectionItem(item))

  const shippingProtectionItems = (cart) => (cart?.items || []).filter(isShippingProtectionItem)

  const freeGiftItems = (cart) => (cart?.items || []).filter(isFreeGiftItem)
  const giftOptedOut = (cart) => giftChoiceEnabled && cart?.attributes?.[giftOptOutAttribute] === 'true'
  const giftDiscountConflict = (cart) => giftChoiceEnabled
    && freeGiftItems(cart).some((item) => item.final_line_price === 0)
    && (cart?.discount_codes || []).some((discount) => discount.applicable === false)

  const paidFreeGiftVariantItems = (cart) => visibleCartItems(cart).filter(isPaidFreeGiftVariantItem)

  const paidCartItems = (cart) => visibleCartItems(cart).filter((item) => !isFreeGiftItem(item) && freeGiftEligibleHandles.has(item.handle))

  const visibleCartItemCount = (items) => items.reduce((totalQuantity, item) => totalQuantity + (item.quantity || 0), 0)

  const displayFinalLinePrice = (item) => {
    return item.final_line_price || 0
  }

  let unavailableGiftSignature = null
  const giftCartSignature = (cart) => JSON.stringify(paidCartItems(cart).map((item) => [
    item.variant_id, item.quantity, item.properties || {}, item.final_line_price,
  ]))

  const isFreeGiftEligible = (cart) => {
    if (giftOptedOut(cart) || giftCartSignature(cart) === unavailableGiftSignature) return false
    if ((cart?.discount_codes || []).some((discount) => discount.applicable === true)) return false
    const freeGiftGoal = roundedCurrencyThreshold(freeGiftThreshold)
    const paidSubtotal = paidCartItems(cart).reduce((amount, item) => amount + displayFinalLinePrice(item), 0)

    return paidSubtotal >= freeGiftGoal && paidSubtotal > 0
  }

  const freeGiftDisplayItem = (item) => item || null

  const stablePropertiesKey = (properties = {}) => JSON.stringify(
    Object.keys(properties || {})
      .sort()
      .reduce((stableProperties, key) => {
        stableProperties[key] = properties[key]
        return stableProperties
      }, {})
  )

  const cartLineGroupKey = (item) => {
    if (!item || isShippingProtectionItem(item) || isFreeGiftItem(item)) return null

    const sellingPlanId = item.selling_plan_allocation?.selling_plan?.id || ''
    return [
      item.variant_id,
      stablePropertiesKey(item.properties),
      sellingPlanId,
    ].join('|')
  }

  const mergeDuplicateDisplayItems = (items) => {
    const mergedItems = []
    const itemIndexes = new Map()

    items.forEach((item) => {
      const groupKey = cartLineGroupKey(item)
      if (!groupKey || !itemIndexes.has(groupKey)) {
        itemIndexes.set(groupKey, mergedItems.length)
        mergedItems.push({
          ...item,
          _astari_cart_line_keys: [{ key: item.key, quantity: item.quantity || 0 }],
        })
        return
      }

      const existingItem = mergedItems[itemIndexes.get(groupKey)]
      existingItem.quantity = (existingItem.quantity || 0) + (item.quantity || 0)
      existingItem.final_line_price = (existingItem.final_line_price || 0) + (item.final_line_price || 0)
      existingItem.original_line_price = (existingItem.original_line_price || 0) + (item.original_line_price || 0)
      existingItem.line_price = (existingItem.line_price || 0) + (item.line_price || 0)
      existingItem._astari_cart_line_keys = [
        ...(existingItem._astari_cart_line_keys || []),
        { key: item.key, quantity: item.quantity || 0 },
      ]
    })

    return mergedItems
  }

  const renderShippingProtection = (cart, currency) => {
    if (!shippingProtection || !shippingProtectionToggle) return null

    const protectionItem = shippingProtectionItems(cart)[0] || null
    const isProtected = Boolean(protectionItem)
    const price = protectionItem?.final_line_price || protectionItem?.final_price || shippingProtectionBasePrice

    shippingProtection.hidden = !shippingProtectionVariantId
    shippingProtectionToggle.setAttribute('aria-checked', isProtected ? 'true' : 'false')
    shippingProtectionToggle.classList.toggle('is-active', isProtected)
    shippingProtectionToggle.disabled = false
    if (shippingProtectionStatus) shippingProtectionStatus.textContent = isProtected ? cartLabels.shippingProtectionOn : cartLabels.shippingProtectionOff
    if (shippingProtectionPrice) shippingProtectionPrice.textContent = formatMoney(price, currency)

    return protectionItem
  }

  const initEmptyRecommendationsAutoScroll = () => {
    const rail = drawer.querySelector('[data-cart-empty-products-track]')
    const cards = Array.from(rail?.querySelectorAll('.astari-cart-empty-product') || [])
    if (!rail || cards.length < 2 || rail.dataset.cartAutoScrollReady === 'true') return

    rail.dataset.cartAutoScrollReady = 'true'
    let userInteracted = false

    const stopAutoScroll = () => {
      userInteracted = true
    }

    const scrollNext = () => {
      if (!rail.isConnected) {
        window.clearInterval(interval)
        return
      }

      if (userInteracted || rail.scrollWidth <= rail.clientWidth + 2) return

      const currentLeft = rail.scrollLeft
      const positions = cards.map((card) => card.offsetLeft - rail.offsetLeft)
      const currentIndex = positions.reduce((nearestIndex, position, index) => {
        const nearestDistance = Math.abs(positions[nearestIndex] - currentLeft)
        const distance = Math.abs(position - currentLeft)
        return distance < nearestDistance ? index : nearestIndex
      }, 0)
      const targetIndex = (currentIndex + 1) % positions.length

      rail.scrollTo({ left: positions[targetIndex], behavior: 'smooth' })
    }

    const interval = window.setInterval(scrollNext, 5000)
    rail.addEventListener('pointerdown', stopAutoScroll, { passive: true })
    rail.addEventListener('wheel', stopAutoScroll, { passive: true })
    rail.addEventListener('touchstart', stopAutoScroll, { passive: true })
    rail.addEventListener('focusin', stopAutoScroll)
  }

  const giftMarketValue = (cart) => {
    const item = (cart.items || []).find(item => String(item.variant_id) === String(freeGiftVariantId))
    return Number(item?.original_price || item?.price || 0) || giftMarketPrices.get(cartCurrency(cart)) || 0
  }

  const loadGiftMarketValue = async (currency) => {
    const handle = upsell?.dataset.cartUpsellHandle
    if (!handle || giftMarketRequests.has(currency)) return
    giftMarketRequests.add(currency)
    try {
      const response = await fetch(route(`products/${encodeURIComponent(handle)}.js`), {headers: {Accept: 'application/json'}})
      if (!response.ok) return
      const product = await response.json()
      const verification = await fetch(route('cart.js'), {headers: {Accept: 'application/json'}})
      if (!verification.ok) return
      const current = await verification.json()
      if (cartCurrency(current) !== currency) return
      const variant = product.variants?.find(item => String(item.id) === String(freeGiftVariantId))
      if (!(Number(variant?.price) > 0)) return
      giftMarketPrices.set(currency, Number(variant.price))
      if (latestUpsellCart && cartCurrency(latestUpsellCart) === currency) renderUpsell(latestUpsellCart)
    } catch (_) {
      // Hide an unverified value rather than relabel an old market's amount.
    }
  }

  const renderUpsell = (cart) => {
    if (!upsell) return
    latestUpsellCart = cart
    const subtotalAmount = paidCartItems(cart)
      .reduce((amount, item) => amount + displayFinalLinePrice(item), 0)
    const freeGiftGoal = roundedCurrencyThreshold(freeGiftThreshold)
    const spendQualifies = subtotalAmount >= freeGiftGoal && subtotalAmount > 0
    const showGiftChoice = giftOptedOut(cart) && spendQualifies
    upsell.classList.toggle('is-gift-choice', showGiftChoice)
    const giftPrice = upsell.querySelector('[data-cart-gift-price]')
    if (giftPrice) giftPrice.hidden = !showGiftChoice
    upsell.hidden = giftCartSignature(cart) === unavailableGiftSignature && !showGiftChoice
    if (upsell.hidden) return
    if (giftRestore) giftRestore.hidden = !showGiftChoice

    const productName = upsell.dataset.cartUpsellProduct || 'Achilles Keychain'
    const productValue = giftMarketValue(cart)
    if (!productValue) loadGiftMarketValue(cartCurrency(cart))
    const freeGiftRemaining = Math.max(0, freeGiftGoal - subtotalAmount)
    const freeGiftUnlocked = spendQualifies && freeGiftItems(cart).some((item) => item.final_line_price === 0)
    const wasUnlocked = upsell.classList.contains('is-gift-unlocked')
    upsell.classList.toggle('is-gift-unlocked', freeGiftUnlocked && !showGiftChoice)
    if (upsellProgress?.parentElement) upsellProgress.parentElement.hidden = showGiftChoice || freeGiftUnlocked
    if (hasRenderedCart && freeGiftUnlocked && !wasUnlocked && !showGiftChoice && drawer.classList.contains('is-open') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      upsell.animate?.([{backgroundColor: '#d1fae5', transform: 'scale(0.985)'}, {backgroundColor: '#ecfdf5', transform: 'scale(1)'}], {duration: 420, easing: 'ease-out'})
    }
    const progress = Math.min(100, (subtotalAmount / Math.max(freeGiftGoal, 1)) * 100)
    const currency = cartCurrency(cart)
    const productValueAmount = productValue > 0 ? productValue : 0
    const productValueFormatted = productValueAmount ? formatMoneyWhole(productValueAmount, currency) : ''

    if (upsellEyebrow) upsellEyebrow.textContent = cartLabels.freeGift
    if (upsellBadge) {
      upsellBadge.hidden = showGiftChoice || !productValueFormatted
      upsellBadge.textContent = productValueFormatted ? interpolateLabel(cartLabels.worth, { AMOUNT: productValueFormatted }) : ''
    }
    const originalPrice = upsell.querySelector('[data-cart-gift-original]')
    if (originalPrice) {
      originalPrice.hidden = !productValueFormatted
      originalPrice.textContent = productValueFormatted
    }
    if (upsellHeading) {
      upsellHeading.textContent = showGiftChoice ? productName : freeGiftUnlocked
        ? cartLabels.freeGiftUnlocked
        : interpolateLabel(cartLabels.addMore, { AMOUNT: formatMoney(freeGiftRemaining, currency) })
    }
    if (upsellText) {
      upsellText.hidden = false
      upsellText.textContent = showGiftChoice ? drawer.dataset.cartGiftBenefit : freeGiftUnlocked
        ? interpolateLabel(cartLabels.freeProductIncluded, { PRODUCT: productName })
        : interpolateLabel(cartLabels.getFreeProduct, { PRODUCT: productName })
    }
    if (upsellProgress) upsellProgress.style.width = `${progress}%`
  }

  const syncServicePromises = (cart) => {
    if (!body || !services) return

    drawer.classList.remove('is-cart-services-hidden')
  }

  const syncAcceleratedCheckoutLayout = () => {
    if (!acceleratedCheckout) return

    syncingAcceleratedCheckout = true
    const finishSync = () => {
      window.setTimeout(() => {
        syncingAcceleratedCheckout = false
      }, 0)
    }

    const walletButtons = Array.from(acceleratedCheckout.children).filter((button) => {
      return !['SCRIPT', 'STYLE', 'TEMPLATE'].includes(button.tagName)
    })
    if (!walletButtons.length) {
      finishSync()
      return
    }

    walletButtons.forEach((button) => {
      button.classList.remove('astari-cart-wallet-button--visible', 'astari-cart-wallet-button--hidden')
      button.removeAttribute('style')
    })
    acceleratedCheckout.removeAttribute('data-wallet-count')

    const checkoutBounds = acceleratedCheckout.getBoundingClientRect()
    if (checkoutBounds.width <= 1 || checkoutBounds.height <= 1) {
      finishSync()
      return
    }

    const renderedButtons = walletButtons.filter((button) => {
      const style = window.getComputedStyle(button)
      const bounds = button.getBoundingClientRect()

      return style.display !== 'none'
        && style.visibility !== 'hidden'
        && style.opacity !== '0'
        && bounds.width > 1
        && bounds.height > 1
    })
    const gap = Number.parseFloat(window.getComputedStyle(acceleratedCheckout).columnGap || '0') || 0
    const isMobileWalletLayout = window.matchMedia('(max-width: 767px)').matches
    const minimumWalletButtonWidth = isMobileWalletLayout ? 115 : 120
    const maxVisibleWalletButtons = isMobileWalletLayout ? 2 : 3
    const calculatedWalletCount = Math.max(
      1,
      Math.min(
        renderedButtons.length,
        maxVisibleWalletButtons,
        Math.floor((checkoutBounds.width + gap) / (minimumWalletButtonWidth + gap))
      )
    )

    const applyWalletLayout = (walletCount) => {
      const visibleButtons = renderedButtons.slice(0, walletCount)
      const slotWidth = visibleButtons.length
        ? Math.max(0, (checkoutBounds.width - (gap * (visibleButtons.length - 1))) / visibleButtons.length)
        : 0

      acceleratedCheckout.dataset.walletCount = String(Math.max(visibleButtons.length, 1))

      walletButtons.forEach((button) => {
        const isVisible = visibleButtons.includes(button)
        button.classList.toggle('astari-cart-wallet-button--visible', isVisible)
        button.classList.toggle('astari-cart-wallet-button--hidden', !isVisible)

        if (isVisible && slotWidth > 0) {
          button.style.setProperty('flex', `0 0 ${slotWidth}px`, 'important')
          button.style.setProperty('width', `${slotWidth}px`, 'important')
          button.style.setProperty('min-width', '0', 'important')
          button.style.setProperty('max-width', 'none', 'important')
        }
      })

      if (visibleButtons.length === 2) {
        const firstBounds = visibleButtons[0].getBoundingClientRect()
        const secondBounds = visibleButtons[1].getBoundingClientRect()
        const desiredSecondLeft = firstBounds.left + firstBounds.width + gap
        const secondOffset = desiredSecondLeft - secondBounds.left

        if (Math.abs(secondOffset) > 1) {
          visibleButtons[1].style.setProperty('transform', `translateX(${secondOffset}px)`, 'important')
        }
      }

      return visibleButtons
    }

    const hasUsableWalletSpacing = (visibleButtons) => {
      if (visibleButtons.length < 2) return true

      const rects = visibleButtons.map((button) => button.getBoundingClientRect())
      return rects.every((rect) => rect.width >= minimumWalletButtonWidth)
        && rects.every((rect) => Math.abs(rect.top - rects[0].top) <= 2)
        && rects.every((rect, index) => {
          if (index === 0) return true
          return rect.left - rects[index - 1].right >= Math.max(0, gap - 1)
        })
    }

    const syncWalletRowHeight = (visibleButtons) => {
      if (!visibleButtons.length) return

      const checkoutButton = drawer.querySelector('.astari-cart-drawer__checkout')
      const checkoutButtonHeight = checkoutButton?.getBoundingClientRect().height || 0
      const maxWalletHeight = Math.max(...visibleButtons.map((button) => button.getBoundingClientRect().height))
      const rowHeight = checkoutButtonHeight || Math.min(Math.max(maxWalletHeight, 44), 64)
      acceleratedCheckout.closest('.astari-cart-accelerated-checkout')
        ?.style
        .setProperty('--astari-cart-wallet-row-height', `${rowHeight}px`)
    }

    let walletCount = calculatedWalletCount
    let visibleButtons = applyWalletLayout(walletCount)

    while (walletCount > 1 && !hasUsableWalletSpacing(visibleButtons)) {
      walletCount -= 1
      visibleButtons = applyWalletLayout(walletCount)
    }

    syncWalletRowHeight(visibleButtons)

    walletButtons.forEach((button) => {
      if (!button.classList.contains('astari-cart-wallet-button--visible')) {
        button.removeAttribute('style')
      }
    })

    finishSync()
  }

  const queueAcceleratedCheckoutLayoutSync = () => {
    window.clearTimeout(acceleratedCheckoutSyncTimer)
    acceleratedCheckoutSyncTimer = window.setTimeout(syncAcceleratedCheckoutLayout, 80)
  }

  const scheduleAcceleratedCheckoutLayoutSync = () => {
    syncAcceleratedCheckoutLayout()
    window.requestAnimationFrame(syncAcceleratedCheckoutLayout)
    window.setTimeout(syncAcceleratedCheckoutLayout, 350)
    window.setTimeout(syncAcceleratedCheckoutLayout, 1200)
  }

  if (acceleratedCheckout && 'MutationObserver' in window) {
    const acceleratedCheckoutObserver = new MutationObserver(() => {
      if (!syncingAcceleratedCheckout) queueAcceleratedCheckoutLayoutSync()
    })

    acceleratedCheckoutObserver.observe(acceleratedCheckout, {
      attributes: true,
      childList: true,
      subtree: true,
    })
  }

  // Recalculate wallet slots when the drawer changes width, including rotation.
  if (acceleratedCheckout && 'ResizeObserver' in window) {
    let previousWalletWidth = 0
    const walletResizeObserver = new ResizeObserver(() => {
      const width = acceleratedCheckout.getBoundingClientRect().width
      if (width > 1 && Math.abs(width - previousWalletWidth) > 1) {
        previousWalletWidth = width
        queueAcceleratedCheckoutLayoutSync()
      }
    })
    walletResizeObserver.observe(acceleratedCheckout)
  }

  const cartItemMarkup = (item, currency) => {
    const isGift = isFreeGiftItem(item)
    const canRemoveGift = giftChoiceEnabled && isGift
    const giftHintId = `AstariGiftHint-${encodeURIComponent(item.key)}`
    const lineKeys = Array.isArray(item._astari_cart_line_keys) ? item._astari_cart_line_keys : []
    const hasGroupedLines = !isGift && lineKeys.length > 1
    const quantityTargetAttribute = hasGroupedLines
      ? `data-cart-line-group="${escapeHTML(JSON.stringify(lineKeys.map((line) => line.key)))}"`
      : `data-cart-quantity="${escapeHTML(item.key)}"`
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="astari-cart-item__variant">${escapeHTML(item.variant_title)}</p>` : ''
    const image = item.image
      ? `<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.product_title)}" width="160" height="160" loading="lazy">`
      : ''
    const compareAmount = item.original_line_price
    const displayLinePrice = displayFinalLinePrice(item)
    const compare = compareAmount > displayLinePrice
      ? `<p class="astari-cart-item__compare">${formatMoney(compareAmount, currency)}</p>`
      : ''
    const quantityControls = isGift
      ? `<div class="astari-cart-item__quantity" aria-label="${escapeHTML(interpolateLabel(cartLabels.quantityFor, { TITLE: item.product_title }))}">
          <button type="button" disabled aria-label="${escapeHTML(cartLabels.decreaseQuantity)}">
            <svg aria-hidden="true" viewBox="0 0 24 24"><path d="M5 12h14"/></svg>
          </button>
          <span>${item.quantity}</span>
          <button type="button" data-cart-add-paid-gift="${escapeHTML(freeGiftVariantId)}" aria-label="${escapeHTML(cartLabels.increaseQuantity)}">
            <svg aria-hidden="true" viewBox="0 0 24 24"><path d="M12 5v14"/><path d="M5 12h14"/></svg>
          </button>
        </div>`
      : `<div class="astari-cart-item__quantity" aria-label="${escapeHTML(interpolateLabel(cartLabels.quantityFor, { TITLE: item.product_title }))}">
          <button type="button" ${quantityTargetAttribute} data-cart-next-quantity="${Math.max(0, item.quantity - 1)}" aria-label="${escapeHTML(cartLabels.decreaseQuantity)}">
            <svg aria-hidden="true" viewBox="0 0 24 24"><path d="M5 12h14"/></svg>
          </button>
          <span>${item.quantity}</span>
          <button type="button" ${quantityTargetAttribute} data-cart-next-quantity="${item.quantity + 1}" aria-label="${escapeHTML(cartLabels.increaseQuantity)}">
            <svg aria-hidden="true" viewBox="0 0 24 24"><path d="M12 5v14"/><path d="M5 12h14"/></svg>
          </button>
        </div>`

    return `
      <article data-cart-motion-key="${escapeHTML(encodeURIComponent(JSON.stringify([item.variant_id || item.id, Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b)), item.selling_plan_allocation?.selling_plan?.id || ''])))}" class="astari-cart-item${isGift ? ' astari-cart-item--free-gift' : ''}">
        <a class="astari-cart-item__image" href="${escapeHTML(item.url)}">${image}</a>
        <div class="astari-cart-item__content">
          <div class="astari-cart-item__heading">
            <div class="astari-cart-item__title">
              <h3><a href="${escapeHTML(item.url)}">${escapeHTML(shortProductTitle(item))}</a></h3>
            </div>
            ${canRemoveGift ? `<span class="astari-cart-gift-hint">
              <button class="astari-cart-gift-remove" type="button" data-cart-remove-gift aria-label="${escapeHTML(cartLabels.removeGift)}" aria-describedby="${escapeHTML(giftHintId)}"><span aria-hidden="true">×</span></button>
              <p id="${escapeHTML(giftHintId)}" role="tooltip">${escapeHTML(cartLabels.giftConflictNote)}</p>
            </span>` : ''}
          </div>
          <div class="astari-cart-item__line">
            <div class="astari-cart-item__meta">
              ${variant}
              <div class="astari-cart-item__prices">
                <p>${formatMoney(displayLinePrice, currency)}</p>
                ${compare}
              </div>
            </div>
            ${quantityControls}
          </div>
        </div>
      </article>
    `
  }

  // Match displayed lines by merchandise identity, not Shopify's changing discount keys.
  const captureCartMotion = () => {
    const items = new Map()
    const focused = document.activeElement
    let focus = null
    itemsContainer?.querySelectorAll('[data-cart-motion-key]').forEach(node => {
      node.getAnimations?.().forEach(animation => animation.cancel())
      if (node.classList.contains('is-cart-item-ghost')) { node.remove(); return }
      const controls = [...node.querySelectorAll('button, a')]
      if (controls.includes(focused)) focus = {key: node.dataset.cartMotionKey, index: controls.indexOf(focused)}
      items.set(node.dataset.cartMotionKey, {rect: node.getBoundingClientRect(), text: node.innerText, clone: node.cloneNode(true)})
    })
    return {items, focus, enabled: hasRenderedCart && drawer.classList.contains('is-open')
      && !window.matchMedia('(prefers-reduced-motion: reduce)').matches}
  }

  const animateCartItems = (before) => {
    if (!itemsContainer) return
    const nodes = [...itemsContainer.querySelectorAll('[data-cart-motion-key]')]
    const keys = new Set(nodes.map(node => node.dataset.cartMotionKey))
    const timing = {duration: 220, easing: 'cubic-bezier(0.22, 1, 0.36, 1)'}
    nodes.forEach(node => {
      const previous = before.items.get(node.dataset.cartMotionKey)
      if (before.enabled && node.animate) {
        const delta = previous ? previous.rect.top - node.getBoundingClientRect().top : 8
        if (!previous || Math.abs(delta) > 1) {
          node.animate([{transform: `translateY(${delta}px)`, opacity: previous ? 1 : 0}, {transform: 'translateY(0)', opacity: 1}], timing)
        }
        if (previous && previous.text !== node.innerText) {
          node.querySelectorAll('.astari-cart-item__prices, .astari-cart-item__quantity span').forEach(value => {
            value.animate?.([{opacity: 0.55}, {opacity: 1}], {duration: 180})
          })
        }
      }
      if (before.focus?.key === node.dataset.cartMotionKey) {
        node.querySelectorAll('button, a')[before.focus.index]?.focus({preventScroll: true})
      }
    })
    if (before.focus && !keys.has(before.focus.key)) {
      (nodes[0]?.querySelector('button, a') || drawer.querySelector('[data-cart-close]'))?.focus({preventScroll: true})
    }
    if (!before.enabled) return
    const containerRect = itemsContainer.getBoundingClientRect()
    before.items.forEach((previous, key) => {
      if (keys.has(key) || !previous.clone.animate) return
      const ghost = previous.clone
      ghost.classList.add('is-cart-item-ghost')
      ghost.inert = true
      ghost.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'))
      ghost.setAttribute('aria-hidden', 'true')
      ghost.style.cssText = `position:absolute;top:${previous.rect.top - containerRect.top}px;left:${previous.rect.left - containerRect.left}px;width:${previous.rect.width}px;margin:0;pointer-events:none;z-index:1;`
      itemsContainer.append(ghost)
      const exit = ghost.animate([{opacity: 1, transform: 'translateY(0)'}, {opacity: 0, transform: 'translateY(-6px)'}], {duration: 160, fill: 'forwards'})
      exit.finished.then(() => ghost.remove()).catch(() => ghost.remove())
    })
  }

  const appliedCartCodes = (cart) => (cart?.discount_codes || []).filter(entry => entry.applicable && entry.code)

  const renderDiscounts = (cart) => {
    // An omitted discount field can resume an older checkout's removed coupon.
    if (checkoutDiscountInput) {
      checkoutDiscountInput.value = appliedCartCodes(cart).map(entry => entry.code).join(',')
      checkoutDiscountInput.disabled = false
    }
    if (!discountSummary) return
    const discounts = (cart.cart_level_discount_applications || []).filter((discount) => discount.total_allocated_amount > 0)
    if (originalTotal) {
      const before = cart.total_price + discounts.filter((discount) => discount.type === 'discount_code').reduce((sum, discount) => sum + discount.total_allocated_amount, 0)
      originalTotal.hidden = before <= cart.total_price
      originalTotal.textContent = formatMoney(before, cartCurrency(cart))
    }
    if (discountForm) discountForm.hidden = !giftOptedOut(cart) || appliedCartCodes(cart).length > 0
    // Shipping and line discounts may not appear in cart-level applications.
    appliedCartCodes(cart).forEach(entry => {
      if (!discounts.some(discount => discount.title.toLowerCase() === entry.code.toLowerCase())) {
        const amount = (cart.items || []).flatMap(item => item.line_level_discount_allocations || [])
          .filter(allocation => allocation.discount_application?.type === 'discount_code' && allocation.discount_application.title.toLowerCase() === entry.code.toLowerCase())
          .reduce((sum, allocation) => sum + allocation.amount, 0)
        discounts.push({title: entry.code, type: 'discount_code', total_allocated_amount: amount})
      }
    })
    discountSummary.hidden = !discounts.length
    discountSummary.innerHTML = discounts.map((discount) => `<div class="astari-cart-discount-row">
      <span class="astari-cart-discount-row__label"><span>${escapeHTML(cartLabels.discount)}</span><span class="astari-cart-discount-row__code">${escapeHTML(discount.title)}${discount.type === 'discount_code' ? `<button type="button" data-cart-remove-discount="${escapeHTML(discount.title)}" aria-label="${escapeHTML(interpolateLabel(cartLabels.removeDiscount, { CODE: discount.title }))}"><span aria-hidden="true">×</span></button>` : ''}</span></span>
      <strong>${discount.total_allocated_amount > 0 ? `−${formatMoney(discount.total_allocated_amount, cartCurrency(cart))}` : ''}</strong>
    </div>`).join('')
  }

  const renderCart = (cart) => {
    globalThis.window?.AstariReferralPilot?.cartChanged(cart)
    const before = captureCartMotion()
    activeCart = cart
    renderDiscounts(cart)
    const currency = cartCurrency(cart)
    const incomingGift = freeGiftItems(cart)[0] || null
    const giftPendingRemoval = Boolean(incomingGift) && !isFreeGiftEligible(cart)
    const cartItems = mergeDuplicateDisplayItems(visibleCartItems(cart)
      .filter(item => !(giftPendingRemoval && isFreeGiftItem(item))).slice())
      .sort((first, second) => {
        const rank = item => isFreeGiftItem(item) ? 0 : isPaidFreeGiftVariantItem(item) ? 1 : 2
        return rank(first) - rank(second)
      })
    renderShippingProtection(cart, currency)
    const itemCount = visibleCartItemCount(cartItems)
    updateCounts(itemCount)
    syncCartTimer(cart, itemCount)
    normalizeShippingProtection(cart).then(changed => {
      if (changed) fetchCart().catch(() => {})
    })
    syncFreeGift(cart)

    if (!itemsContainer || !footer || !total) return

    if (!cartItems.length) {
      drawer.classList.add('is-cart-empty')
      itemsContainer.innerHTML = emptyHTML
      footer.hidden = true
      if (filledContent) filledContent.hidden = false
      if (upsell) upsell.hidden = true
      total.textContent = formatMoney(0, currency)
      initEmptyRecommendationsAutoScroll()
      renderUpsell(cart)
      syncServicePromises(cart)
      scheduleAcceleratedCheckoutLayoutSync()
      hasRenderedCart = true




      animateCartItems(before)

      return
    }

    drawer.classList.remove('is-cart-empty')
    itemsContainer.innerHTML = cartItems.map(item => cartItemMarkup(item, currency)).join('')




    if (filledContent) filledContent.hidden = false
    if (upsell) upsell.hidden = false
    footer.hidden = false
    total.textContent = formatMoney(cart.total_price, currency)
    renderUpsell(cart)
    syncServicePromises(cart)

    animateCartItems(before)
    scheduleAcceleratedCheckoutLayoutSync()
    hasRenderedCart = true
  }

  const fetchCart = async () => {
    const diagnostics = globalThis.window?.AstariCartDiagnostics
    let phase = 'request'
    let status
    diagnostics?.phase(phase)
    try {
      const response = await fetch(route('cart.js'), {
        headers: { Accept: 'application/json' },
      })
      phase = 'http'
      status = response.status
      diagnostics?.phase(phase)
      if (!response.ok) throw new Error(cartStatusLabels.couldNotLoad)
      phase = 'json'
      diagnostics?.phase(phase)
      const cart = await response.json()
      phase = 'render'
      diagnostics?.phase(phase)
      renderCart(cart)
      diagnostics?.phase('ready')
      return cart
    } catch (error) {
      diagnostics?.failure(phase, error, status)
      throw error
    }
  }

  const syncCartQuantityTargets = (cart) => {
    const previousItems = activeCart?.items || []
    const currentItems = cart?.items || []
    drawer.querySelectorAll('[data-cart-quantity], [data-cart-line-group]').forEach((button) => {
      const previousKeys = button.hasAttribute('data-cart-line-group')
        ? JSON.parse(button.dataset.cartLineGroup || '[]')
        : [button.dataset.cartQuantity]
      const previous = previousItems.find((item) => previousKeys.includes(item.key))
      const groupKey = cartLineGroupKey(previous)
      if (!groupKey) return
      const lines = currentItems.filter((item) => cartLineGroupKey(item) === groupKey)
      if (!lines.length) return
      if (lines.length > 1) {
        button.dataset.cartLineGroup = JSON.stringify(lines.map((item) => item.key))
        button.removeAttribute('data-cart-quantity')
      } else {
        button.dataset.cartQuantity = lines[0].key
        button.removeAttribute('data-cart-line-group')
      }
    })
  }

  const renderCartSummary = (cart) => {
    globalThis.window?.AstariReferralPilot?.cartChanged(cart)
    // Protection can qualify or disqualify a merchandise discount. Refresh the
    // cards when Shopify changes their prices, otherwise keep them stationary.
    const merchandisePrices = (value) => JSON.stringify(visibleCartItems(value || {items: []})
      .map(item => [lineIdentity(item), item.quantity, item.original_line_price, item.final_line_price])
      .sort((first, second) => String(first[0]).localeCompare(String(second[0]))))
    if (merchandisePrices(activeCart) !== merchandisePrices(cart)) {
      renderCart(cart)
      return
    }
    syncCartQuantityTargets(cart)
    activeCart = cart
    renderDiscounts(cart)
    const currency = cartCurrency(cart)

    renderShippingProtection(cart, currency)
    if (total) total.textContent = formatMoney(cart.total_price, currency)
    scheduleAcceleratedCheckoutLayoutSync()
  }

  const readCart = async () => {
    const response = await fetch(route('cart.js'), {headers: {Accept: 'application/json'}})
    if (!response.ok) throw new Error(cartStatusLabels.couldNotLoad)
    return response.json()
  }

  // Discount recalculation changes line keys. Resolve by variant, properties and
  // selling plan before writing; never fall back to variant ID alone.
  const lineIdentity = (item) => item ? JSON.stringify([
    String(item.variant_id), stablePropertiesKey(item.properties),
    String(item.selling_plan_allocation?.selling_plan?.id || ''),
  ]) : null

  const changeCartLine = async (key, quantity, originalItem = activeCart?.items?.find(item => item.key === key)) => {
    let current = await readCart()
    const identity = lineIdentity(originalItem)
    for (let attempt = 0; attempt < 2; attempt++) {
      const matches = current.items.filter(item => identity && lineIdentity(item) === identity)
      const item = current.items.find(item => item.key === key) || (matches.length === 1 ? matches[0] : null)
      if (!item) {
        if (quantity === 0 && matches.length === 0) return current
        throw new Error(cartStatusLabels.couldNotUpdateCart)
      }
      const response = await fetch(route('cart/change.js'), {
        method: 'POST', headers: {Accept: 'application/json', 'Content-Type': 'application/json'},
        body: JSON.stringify({id: item.key, quantity}),
      })
      if (response.ok) return readCart()
      // Retry only a stale-key response. Inventory and network errors are not retries.
      if (attempt || response.status !== 400) throw new Error(cartStatusLabels.couldNotUpdateCart)
      current = await readCart()
      if (current.items.some(line => line.key === item.key)) throw new Error(cartStatusLabels.couldNotUpdateCart)
    }
  }

  const setShippingProtectionQuantity = async (quantity) => {
    if (!shippingProtectionVariantId) return null

    const response = await fetch(route('cart/update.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates: {
          [shippingProtectionVariantId]: quantity,
        },
      }),
    })

    if (!response.ok) {
      const error = await response.json().catch(() => ({}))
      throw new Error(error.description || cartStatusLabels.couldNotUpdateShippingProtection)
    }

    return response.json()
  }

  const addShippingProtection = async () => {
    if (!shippingProtectionVariantId || addingShippingProtection) return false

    addingShippingProtection = true

    try {
      return setShippingProtectionQuantity(1)
    } catch (error) {
      throw new Error(error.message || cartStatusLabels.couldNotAddShippingProtection)
    } finally {
      addingShippingProtection = false
    }
  }

  const ensureShippingProtection = async (cart) => {
    if (!shippingProtectionVariantId) return false
    if (!visibleCartItems(cart).length) return false
    if ((cart.items || []).some(isShippingProtectionItem)) return false

    return addShippingProtection()
  }

  const normalizeShippingProtection = async (cart) => {
    if (!shippingProtectionVariantId || cleaningShippingProtection) return false

    const cartItems = visibleCartItems(cart)
    const protectionItems = shippingProtectionItems(cart)
    if (!protectionItems.length) return false

    const shouldRemoveProtection = cartItems.length === 0
    const hasDuplicateLines = protectionItems.length > 1
    const hasDuplicateQuantity = protectionItems.some((item) => (item.quantity || 0) > 1)
    if (!shouldRemoveProtection && !hasDuplicateLines && !hasDuplicateQuantity) return false

    cleaningShippingProtection = true

    try {
      await setShippingProtectionQuantity(shouldRemoveProtection ? 0 : 1)
      await fetchCart()
      return true
    } catch (_error) {
      return false
    } finally {
      cleaningShippingProtection = false
    }
  }

  const productCartAddRequest = (form) => {
    const data = new FormData(form)
    const offer = form.matches('[data-product-form]') ? form.closest('[data-product-root]')?.querySelector('[data-keychain-offer]') : null
    const root = offer?.closest('[data-product-root]')
    const variants = JSON.parse(root?.querySelector('[data-product-json]')?.textContent || '[]')
    const stock = JSON.parse(root?.querySelector('[data-product-stock-json]')?.textContent || '{}')[String(data.get('id'))] || {}
    const variant = variants.find(item => String(item.id) === String(data.get('id')))
    const requiredKeychains = Number(data.get('quantity') || 1) * (String(data.get('id')) === offer?.dataset.keychainVariant ? 2 : 1)
    const enoughKeychains = Number(offer?.dataset.keychainStock || Infinity) >= requiredKeychains
    const eligible = variant?.available && stock.preorder !== true && (stock.physicalOutOfStock !== true || stock.preorderOverride === true) && enoughKeychains
    if (!offer || offer.hidden || !eligible || !offer.querySelector('input[value="bundle"]:checked')) {
      return {method: 'POST', headers: {Accept: 'application/json'}, body: data}
    }
    const quantity = Number(data.get('quantity') || 1)
    const ring = {id: data.get('id'), quantity, properties: {}}
    for (const [name, value] of data.entries()) {
      const property = name.match(/^properties\[(.+)\]$/)
      if (property) ring.properties[property[1]] = value
    }
    if (data.get('selling_plan')) ring.selling_plan = data.get('selling_plan')
    return {method: 'POST', headers: {Accept: 'application/json', 'Content-Type': 'application/json'},
      body: JSON.stringify({items: [ring, {id: offer.dataset.keychainVariant, quantity,
        properties: {_astari_keychain_bundle: 'true'}}]})}
  }

  const addFreeGift = async () => {
    if (!freeGiftVariantId) return null

    const response = await fetch(route('cart/add.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: freeGiftVariantId,
        quantity: 1,
        properties: {
          _astari_free_gift: 'true',
        },
      }),
    })

    if (!response.ok) {
      const error = await response.json().catch(() => ({}))
      throw new Error(error.description || cartStatusLabels.couldNotAddProduct)
    }

    const added = await response.json()
    const refreshed = await readCart()
    const chargedGifts = freeGiftItems(refreshed).filter((item) => item.final_line_price > 0)
    if (chargedGifts.length) {
      for (const item of chargedGifts) await changeCartLine(item.key, 0, item)
      unavailableGiftSignature = giftCartSignature(await readCart())
    }
    return added
  }

  const addPaidFreeGiftVariant = async () => {
    if (!freeGiftVariantId) return null

    setStatus(cartStatusLabels.addingToCart)
    const giftItem = freeGiftItems(activeCart)[0] || null
    const paidGiftItem = paidFreeGiftVariantItems(activeCart)[0] || null
    const optimisticPrice = giftItem?.original_price || giftItem?.price || giftItem?.original_line_price || 0

    if (giftItem && activeCart) {

      const optimisticItems = paidGiftItem
        ? (activeCart.items || []).map((item) => {
            if (item.key !== paidGiftItem.key) return item

            const nextQuantity = (item.quantity || 0) + 1
            const unitFinalPrice = item.quantity ? Math.round((item.final_line_price || optimisticPrice) / item.quantity) : optimisticPrice
            const unitOriginalPrice = item.quantity ? Math.round((item.original_line_price || optimisticPrice) / item.quantity) : optimisticPrice

            return {
              ...item,
              quantity: nextQuantity,
              final_line_price: (item.final_line_price || 0) + unitFinalPrice,
              original_line_price: (item.original_line_price || 0) + unitOriginalPrice,
            }
          })
        : [
            ...(activeCart.items || []),
            {
              ...giftItem,
              key: `${giftItem.key}:paid-gift-pending:${Date.now()}`,
              properties: {},
              quantity: 1,
              final_price: optimisticPrice,
              final_line_price: optimisticPrice,
              original_price: optimisticPrice,
              original_line_price: optimisticPrice,
              line_level_discount_allocations: [],
            },
          ]
      const optimisticCart = {
        ...activeCart,
        item_count: (activeCart.item_count || 0) + 1,
        items: optimisticItems,
        items_subtotal_price: (activeCart.items_subtotal_price || 0) + optimisticPrice,
        original_total_price: (activeCart.original_total_price || activeCart.total_price || 0) + optimisticPrice,
        total_price: (activeCart.total_price || 0) + optimisticPrice,
      }

      renderCart(optimisticCart)

    }

    const response = await fetch(route('cart/add.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: freeGiftVariantId,
        quantity: 1,
      }),
    })

    if (!response.ok) {
      const error = await response.json().catch(() => ({}))
      throw new Error(error.description || cartStatusLabels.couldNotAddProduct)
    }

    await fetchCart()
    setStatus('')
    return true
  }

  const syncFreeGift = async (cart) => {
    if (!freeGiftVariantId || syncingFreeGift || updatingGiftChoice || changingCartQuantity || addingProduct || applyingDiscount || cleaningShippingProtection) return false

    const isEligible = isFreeGiftEligible(cart)
    const giftItems = freeGiftItems(cart)
    const shouldAddGift = isEligible && giftItems.length === 0
    const shouldRemoveGift = giftItems.length > 0 && (!isEligible || giftItems.some((item) => item.final_line_price > 0))
    const shouldNormalizeGift = isEligible && giftItems.some((item, index) => index > 0 || (item.quantity || 0) !== 1)

    if (!shouldAddGift && !shouldRemoveGift && !shouldNormalizeGift) return false

    syncingFreeGift = true
    setCartChoiceBusy(true, 'gift-sync')

    try {
      if (shouldAddGift) {
        await addFreeGift()
      } else if (shouldRemoveGift) {
        for (const item of giftItems) {
          await changeCartLine(item.key, 0, item)
        }
      } else if (shouldNormalizeGift) {
        for (const [index, item] of giftItems.entries()) {
          await changeCartLine(item.key, index === 0 ? 1 : 0, item)
        }
      }

      await fetchCart()
      return true
    } catch (_error) {
      return false
    } finally {
      syncingFreeGift = false
      setCartChoiceBusy(false, 'gift-sync')
    }
  }

  const cartBusyReasons = new Set()
  const referralPending = () => document.documentElement.dataset.astariReferralPending === 'true'
  const setCartChoiceBusy = (busy, reason = 'cart') => {
    if (busy) cartBusyReasons.add(reason)
    else cartBusyReasons.delete(reason)
    const checkoutBusy = cartBusyReasons.size > 0 || referralPending()
    const checkout = drawer.querySelector('button[name="checkout"]')
    if (checkout) checkout.disabled = checkoutBusy
    const accelerated = drawer.querySelector('.astari-cart-accelerated-checkout')
    if (accelerated) accelerated.inert = checkoutBusy
    drawer.setAttribute('aria-busy', String(checkoutBusy))
    globalThis.window?.AstariCartDiagnostics?.busy(cartBusyReasons, referralPending())
    globalThis.window?.AstariReferralPilot?.refreshStatus()
  }
  window.AstariCartReferral = {
    reflect: cart => renderCart(cart),
    invitationDiscountAllowed: cart => giftOptedOut(cart) || (!freeGiftItems(cart).length && !isFreeGiftEligible(cart)),
    waitForIdle: async signal => {
      while (cartBusyReasons.size || applyingDiscount || updatingGiftChoice || syncingFreeGift || changingCartQuantity || addingProduct || cleaningShippingProtection) {
        if (signal.aborted) throw new Error('Cart wait cancelled')
        await new Promise(resolve => window.setTimeout(resolve, 25))
      }
    },
  }
  document.addEventListener('astari:referral-pending', () => setCartChoiceBusy(false, 'referral-refresh'))
  let waitingReferralCheckout = false
  drawer.querySelector('button[name="checkout"]')?.form?.addEventListener('submit', event => {
    globalThis.window?.AstariCartDiagnostics?.submit(referralPending() || cartBusyReasons.size > 0)
    if (!referralPending() && !cartBusyReasons.size) return
    event.preventDefault()
    if (!referralPending() || waitingReferralCheckout) return
    waitingReferralCheckout = true
    const form = event.currentTarget
    const submitter = event.submitter
    window.AstariReferralPilot?.ready().then(() => {
      if (!referralPending() && !cartBusyReasons.size) form.requestSubmit(submitter || undefined)
    }).catch(() => {}).finally(() => { waitingReferralCheckout = false })
  })
  setCartChoiceBusy(false, 'referral-refresh')

  const setGiftChoice = async (optOut) => {
    if (!giftChoiceEnabled || updatingGiftChoice || syncingFreeGift || applyingDiscount) throw new Error(cartStatusLabels.couldNotUpdateItem)
    updatingGiftChoice = true
    setCartChoiceBusy(true, 'gift-choice')
    setStatus(cartStatusLabels.updatingCart)
    try {
      const currentResponse = await fetch(route('cart.js'), {headers: {Accept: 'application/json'}})
      if (!currentResponse.ok) throw new Error(cartStatusLabels.couldNotLoad)
      const current = await currentResponse.json()
      const updates = optOut ? Object.fromEntries((current.items || []).filter((item) => isFreeGiftItem(item)).map((item) => [item.key, 0])) : {}
      const rememberedCodesAttribute = '_astari_discount_codes_before_gift'
      const existingCodes = (current.discount_codes || []).map(entry => entry.code).filter(Boolean).join(',')
      const rememberedCodes = current.attributes?.[rememberedCodesAttribute] || ''
      const attributes = {[giftOptOutAttribute]: optOut ? 'true' : ''}
      if (!optOut && existingCodes) attributes[rememberedCodesAttribute] = existingCodes
      const discountChoice = !optOut ? {discount: ''} : !existingCodes && rememberedCodes ? {discount: rememberedCodes} : {}
      const response = await fetch(route('cart/update.js'), {
        method: 'POST', headers: {Accept: 'application/json', 'Content-Type': 'application/json'},
        body: JSON.stringify({attributes, updates, ...discountChoice}),
      })
      if (!response.ok) throw new Error(cartStatusLabels.couldNotUpdateCart)
      const updated = await response.json()
      renderCart(updated)
      if (!optOut && isFreeGiftEligible(updated) && !freeGiftItems(updated).length) await addFreeGift()
      await fetchCart()
      setStatus('')
    } finally {
      updatingGiftChoice = false
      setCartChoiceBusy(false, 'gift-choice')
    }
  }

  const removeCartDiscount = async (code) => {
    if (!giftChoiceEnabled || applyingDiscount || updatingGiftChoice || syncingFreeGift || changingCartQuantity || addingProduct) return
    applyingDiscount = true
    setCartChoiceBusy(true, 'discount-remove')
    try {
      globalThis.window?.AstariCartDiagnostics?.removal('read')
      const current = await readCart()
      const keep = value => value.toLowerCase() !== code.toLowerCase()
      const codes = (current.discount_codes || []).map(entry => entry.code).filter(value => value && keep(value))
      const remembered = String(current.attributes?._astari_discount_codes_before_gift || '').split(',').filter(value => value && keep(value))
      globalThis.window?.AstariCartDiagnostics?.removal('update')
      const response = await fetch(route('cart/update.js'), {
        method: 'POST', headers: {Accept: 'application/json', 'Content-Type': 'application/json'},
        body: JSON.stringify({discount: codes.join(','), attributes: {_astari_discount_codes_before_gift: remembered.join(',')}}),
      })
      if (!response.ok) throw new Error(cartStatusLabels.couldNotUpdateCart)
      globalThis.window?.AstariCartDiagnostics?.removal('refresh')
      const cart = await fetchCart()
      globalThis.window?.AstariCartDiagnostics?.removal('verify')
      if (appliedCartCodes(cart).some(entry => !keep(entry.code))) throw new Error(cartStatusLabels.couldNotUpdateCart)
      if (discountInput) discountInput.value = ''
      if (discountFeedback) discountFeedback.hidden = true
      if (discountForm && !discountForm.hidden) discountInput?.focus({preventScroll: true})
      else discountSummary.querySelector('button')?.focus({preventScroll: true})
      setStatus('')
      globalThis.window?.AstariCartDiagnostics?.removal('ready')
    } catch (_error) {
      globalThis.window?.AstariCartDiagnostics?.removal('failed')
      await fetchCart().catch(() => {})
      setStatus(cartStatusLabels.couldNotUpdateCart, true)
    } finally {
      applyingDiscount = false
      setCartChoiceBusy(false, 'discount-remove')
    }
  }

  discountForm?.addEventListener('submit', async (event) => {
    event.preventDefault()
    if (referralPending()) await window.AstariReferralPilot?.ready()
    if (!giftChoiceEnabled || !giftOptedOut(activeCart) || applyingDiscount || updatingGiftChoice) return
    const code = discountInput.value.trim()
    if (!code) return
    applyingDiscount = true
    const button = discountForm.querySelector('button')
    button.disabled = true
    setCartChoiceBusy(true, 'discount-apply')
    discountFeedback.hidden = true
    try {
      const currentResponse = await fetch(route('cart.js'), {headers: {Accept: 'application/json'}})
      if (!currentResponse.ok) throw new Error(cartStatusLabels.couldNotUpdateCart)
      const current = await currentResponse.json()
      if (!giftOptedOut(current)) {
        await fetchCart()
        throw new Error(cartStatusLabels.couldNotUpdateCart)
      }
      const codes = [...new Map([...(current.discount_codes || []).filter((entry) => entry.applicable).map((entry) => entry.code), code].map((value) => [value.toLowerCase(), value])).values()]
      const response = await fetch(route('cart/update.js'), {
        method: 'POST', headers: {Accept: 'application/json', 'Content-Type': 'application/json'},
        body: JSON.stringify({discount: codes.join(',')}),
      })
      if (!response.ok) throw new Error(cartStatusLabels.couldNotUpdateCart)
      await response.json()
      const cart = await fetchCart()
      const applied = (cart.discount_codes || []).some((entry) => entry.code.toLowerCase() === code.toLowerCase() && entry.applicable)
      discountFeedback.textContent = applied ? cartLabels.discountApplied : cartLabels.discountInvalid
      discountFeedback.classList.toggle('is-error', !applied)
    } catch (_error) {
      await fetchCart().catch(() => {})
      discountFeedback.textContent = cartStatusLabels.couldNotUpdateCart
      discountFeedback.classList.add('is-error')
    } finally {
      discountFeedback.hidden = false
      applyingDiscount = false
      button.disabled = false
      setCartChoiceBusy(false, 'discount-apply')
    }
  })

  const openDrawer = async () => {
    drawer.hidden = false
    syncCartViewportHeight()
    document.body.classList.add('astari-cart-open')
    window.requestAnimationFrame(() => drawer.classList.add('is-open'))
    scheduleAcceleratedCheckoutLayoutSync()

    try {
      await fetchCart()
      setStatus('')
      scheduleAcceleratedCheckoutLayoutSync()
    } catch (_error) {
      setStatus(cartStatusLabels.couldNotRefresh, true)
    }
  }

  const closeDrawer = () => {
    itemsContainer?.querySelectorAll('[data-cart-motion-key]').forEach(node => {
      node.getAnimations?.().forEach(animation => animation.cancel())
      if (node.classList.contains('is-cart-item-ghost')) node.remove()
    })
    if (cartTimerInterval) window.clearInterval(cartTimerInterval)
    cartTimerInterval = null
    drawer.classList.remove('is-open')
    document.body.classList.remove('astari-cart-open')
    window.setTimeout(() => {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true
    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 260)
  }

  const changeQuantity = async (key, quantity) => changeLineGroupQuantity([key], quantity)

  const changeLineGroupQuantity = async (keys, quantity) => {
    if (!keys.length || changingCartQuantity) return
    if (!Number.isInteger(quantity) || quantity < 0) throw new Error(cartStatusLabels.couldNotUpdateCart)
    const original = activeCart?.items?.find(item => keys.includes(item.key))
    const identity = lineIdentity(original)
    if (!identity) throw new Error(cartStatusLabels.couldNotUpdateCart)
    changingCartQuantity = true
    setCartChoiceBusy(true, 'quantity')
    try {
      let current = await readCart()
      // Shopify may split/merge a line when only some units receive a discount.
      // Adjust the group total, rather than consolidating those backend-owned lines.
      for (let attempt = 0; attempt < 10; attempt++) {
        const lines = current.items.filter(item => lineIdentity(item) === identity)
        const count = lines.reduce((sum, item) => sum + item.quantity, 0)
        if (count === quantity) break
        if (!lines.length) throw new Error(cartStatusLabels.couldNotUpdateCart)
        const item = lines[0]
        current = await changeCartLine(item.key, Math.max(0, item.quantity + quantity - count), item)
        if (attempt === 9 && current.items.filter(item => lineIdentity(item) === identity).reduce((sum, item) => sum + item.quantity, 0) !== quantity) {
          throw new Error(cartStatusLabels.couldNotUpdateCart)
        }
      }
    } finally {
      try {
        const refreshed = await fetchCart()
        changingCartQuantity = false
        await syncFreeGift(refreshed)
      } finally {
        changingCartQuantity = false
        setCartChoiceBusy(false, 'quantity')
      }
    }
    setStatus('')
  }

  const toggleShippingProtection = async (enabled) => {
    if (!shippingProtectionVariantId || !shippingProtectionToggle) return

    shippingProtectionToggle.disabled = true
    setStatus(enabled ? cartStatusLabels.addingShippingProtection : cartStatusLabels.removingShippingProtection)

    const protectionItem = shippingProtectionItems(activeCart)[0] || null
    let cart = activeCart

    if (enabled && !protectionItem) {
      cart = await addShippingProtection()
    } else if (!enabled && protectionItem) {
      cart = await setShippingProtectionQuantity(0)
    }

    if (cart) {
      const response = await fetch(route('cart.js'), {headers: {Accept: 'application/json'}})
      if (!response.ok) throw new Error(cartStatusLabels.couldNotLoad)
      renderCartSummary(await response.json())
    }
    setStatus('')
  }

  document.addEventListener('click', async (event) => {
    const cartOpen = event.target.closest('[data-cart-open]')
    const cartClose = event.target.closest('[data-cart-close]')
    const quantityButton = event.target.closest('[data-cart-quantity]')
    const lineGroupButton = event.target.closest('[data-cart-line-group]')
    const paidGiftButton = event.target.closest('[data-cart-add-paid-gift]')
    const protectionButton = event.target.closest('[data-cart-protection-toggle]')
    const removeDiscountButton = event.target.closest('[data-cart-remove-discount]')
    const giftChoiceButton = event.target.closest('[data-cart-remove-gift], [data-cart-restore-gift]')
    if ((referralPending() || applyingDiscount || updatingGiftChoice || syncingFreeGift || changingCartQuantity || addingProduct || cleaningShippingProtection) && (giftChoiceButton || quantityButton || lineGroupButton || paidGiftButton || protectionButton || removeDiscountButton)) {
      event.preventDefault()
      return
    }
    drawer.querySelectorAll('.astari-cart-gift-hint[open]').forEach((hint) => {
      if (!hint.contains(event.target)) hint.open = false
    })

    if (removeDiscountButton) {
      event.preventDefault()
      await removeCartDiscount(removeDiscountButton.dataset.cartRemoveDiscount)
      return
    }

    if (giftChoiceButton) {
      event.preventDefault()
      giftChoiceButton.setAttribute('aria-disabled', 'true')
      try {
        await setGiftChoice(giftChoiceButton.hasAttribute('data-cart-remove-gift'))
      } catch (_error) {
        setStatus(cartStatusLabels.couldNotUpdateItem, true)
        fetchCart().catch(() => {})
      } finally {
        giftChoiceButton.removeAttribute('aria-disabled')
      }
    }

    if (cartOpen) {
      event.preventDefault()
      openDrawer()
    }

    if (cartClose) {
      event.preventDefault()
      closeDrawer()
    }

    if (protectionButton) {
      event.preventDefault()
      const nextState = protectionButton.getAttribute('aria-checked') !== 'true'
      setCartChoiceBusy(true, 'protection')
      try {
        await toggleShippingProtection(nextState)
      } catch (error) {
        setStatus(error.message || cartStatusLabels.couldNotUpdateShippingProtection, true)
        shippingProtectionToggle.disabled = false
      } finally {
        setCartChoiceBusy(false, 'protection')
      }
    }

    if (quantityButton) {
      event.preventDefault()
      quantityButton.setAttribute('aria-disabled', 'true')

      try {
        await changeQuantity(quantityButton.dataset.cartQuantity, Number(quantityButton.dataset.cartNextQuantity))
      } catch (_error) {
        setStatus(cartStatusLabels.couldNotUpdateItem, true)
      } finally {
        quantityButton.removeAttribute('aria-disabled')
      }
    }

    if (lineGroupButton) {
      event.preventDefault()
      lineGroupButton.setAttribute('aria-disabled', 'true')

      try {
        const lineKeys = JSON.parse(lineGroupButton.dataset.cartLineGroup || '[]')
        await changeLineGroupQuantity(lineKeys, Number(lineGroupButton.dataset.cartNextQuantity))
      } catch (_error) {
        setStatus(cartStatusLabels.couldNotUpdateItem, true)
      } finally {
        lineGroupButton.removeAttribute('aria-disabled')
      }
    }

    if (paidGiftButton) {
      event.preventDefault()
      paidGiftButton.setAttribute('aria-disabled', 'true')

      setCartChoiceBusy(true, 'paid-gift')
      try {
        await addPaidFreeGiftVariant()
      } catch (_error) {


        fetchCart().catch(() => {})
        setStatus(cartStatusLabels.couldNotAddProductPeriod, true)
      } finally {
        paidGiftButton.removeAttribute('aria-disabled')
        setCartChoiceBusy(false, 'paid-gift')
      }
    }
  })

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-cart-add-form]')
    if (!form) return

    event.preventDefault()
    if (referralPending()) await window.AstariReferralPilot?.ready()
    if (addingProduct || changingCartQuantity || updatingGiftChoice || syncingFreeGift || applyingDiscount) return
    addingProduct = true
    setCartChoiceBusy(true, 'product-add')
    const isAlternativeForm = form.matches('[data-alternative-cart-form]')
    const submitButton = event.submitter || form.querySelector('button[type="submit"]')
    const productRoot = form.closest('[data-product-root]')
    const floatingSubmitButtons = isAlternativeForm ? [] : productRoot?.querySelectorAll('[data-product-floating-submit]') || []
    const submittedFromFloatingButton = form.dataset.productFloatingSubmitRequested === 'true'
    delete form.dataset.productFloatingSubmitRequested
    if (productRoot && !isAlternativeForm) {
      document.body.classList.toggle('astari-product-primary-adding', !submittedFromFloatingButton)
      document.body.classList.toggle('astari-product-floating-adding', submittedFromFloatingButton)
    }
    submitButton?.setAttribute('disabled', 'disabled')
    if (isAlternativeForm) submitButton?.classList.add('is-loading')
    floatingSubmitButtons.forEach((button) => {
      button.setAttribute('disabled', 'disabled')
      if (submittedFromFloatingButton) {
        button.classList.add('is-loading', 'is-visible')
        button.classList.remove('is-suppressed', 'is-entering-from-bottom', 'is-docked')
        button.setAttribute('aria-hidden', 'false')
      } else {
        button.classList.remove('is-loading', 'is-visible', 'is-entering-from-bottom')
        button.classList.add('is-suppressed')
        button.setAttribute('aria-hidden', 'true')
      }
    })
    document.body.classList.add('astari-cart-adding')
    setStatus(cartStatusLabels.addingToCart)

    try {
      const response = await fetch(route('cart/add.js'), productCartAddRequest(form))

      if (!response.ok) {
        const error = await response.json().catch(() => ({}))
        throw new Error(error.description || cartStatusLabels.couldNotAddProduct)
      }

      form.closest('[data-product-card]')?.classList.remove('is-revealed')
      const cartAfterProductAdd = await fetchCart()
      let protectionAdded = false
      let protectionError = false

      try {
        protectionAdded = await ensureShippingProtection(cartAfterProductAdd)
      } catch (_error) {
        protectionError = true
      }

      if (protectionAdded) await fetchCart()
      setStatus(protectionError ? cartStatusLabels.addedToCartProtectionFailed : cartStatusLabels.addedToCart, protectionError)
      openDrawer()
    } catch (error) {
      setStatus(error.message || cartStatusLabels.couldNotAddProductPeriod, true)
    } finally {
      const refreshed = await fetchCart().catch(() => null)
      addingProduct = false
      if (refreshed) await syncFreeGift(refreshed)
      if ((isAlternativeForm && (form.closest('[data-product-twin-card]')?.hidden || !form.querySelector('[data-product-twin-id]')?.value)) || submitButton?.dataset.productChoiceAvailable === 'false') {
        submitButton?.setAttribute('disabled', 'disabled')
      } else {
        submitButton?.removeAttribute('disabled')
      }
      if (isAlternativeForm) submitButton?.classList.remove('is-loading')
      floatingSubmitButtons.forEach((button) => {
        button.classList.remove('is-loading')
        if (!submittedFromFloatingButton) button.classList.remove('is-suppressed')
        button.removeAttribute('disabled')
      })
      document.body.classList.remove('astari-cart-adding', 'astari-product-primary-adding', 'astari-product-floating-adding')
      setCartChoiceBusy(false, 'product-add')
    }
  })

  const chatLauncher = document.querySelector('[data-product-chat-launcher]')
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  if (chatLauncher && !prefersReducedMotion) {
    window.setTimeout(() => {
      if (document.visibilityState !== 'visible') return
      chatLauncher.classList.add('is-nudging')
      window.setTimeout(() => chatLauncher.classList.remove('is-nudging'), 3200)
    }, 1200)
  }

  const prepareShopifyChat = () => {
    const shopifyChat = document.querySelector('shopify-chat')
    const shopifyChatRoot = shopifyChat?.shadowRoot
    const runtimeRoot = shopifyChatRoot?.querySelector('shopify-agent-runtime')?.shadowRoot
    const shopifyChatActivator = runtimeRoot?.querySelector('button.activator') || shopifyChatRoot?.querySelector('button.activator')
    if (!shopifyChat || !shopifyChatRoot) return false

    shopifyChatActivator?.style.setProperty('display', 'none', 'important')
    if (shopifyChatActivator) {
      shopifyChat.classList.toggle('astari-shopify-chat-open', shopifyChatActivator.getAttribute('aria-expanded') === 'true')
    }

    // Observe both Inbox shells: a closed, offscreen panel can tint Safari's toolbar.
    ;[shopifyChatRoot, runtimeRoot].filter(Boolean).forEach((root) => {
      if (root.astariActivatorObserver) return
      root.astariActivatorObserver = new MutationObserver(prepareShopifyChat)
      root.astariActivatorObserver.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded'] })
    })

    return Boolean(shopifyChatActivator)
  }

  let shopifyChatPreparationAttempts = 0
  const prepareShopifyChatWhenReady = () => {
    if (prepareShopifyChat() || shopifyChatPreparationAttempts >= 20) return
    shopifyChatPreparationAttempts += 1
    window.setTimeout(prepareShopifyChatWhenReady, 250)
  }
  prepareShopifyChatWhenReady()

  document.addEventListener('click', (event) => {
    const chatLauncher = event.target.closest('[data-product-chat-launcher]')
    if (!chatLauncher) return

    event.preventDefault()

    const openShopifyChat = () => {
      const shopifyChatRoot = document.querySelector('shopify-chat')?.shadowRoot
      // Inbox replaces its initial launcher with a nested runtime after first open.
      const shopifyChatActivator = shopifyChatRoot?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('button.activator')
        || shopifyChatRoot?.querySelector('button.activator')
      if (!shopifyChatActivator) return false
      if (shopifyChatActivator.getAttribute('aria-expanded') !== 'true') shopifyChatActivator.click()
      prepareShopifyChat()
      return true
    }

    const openGorgiasChat = () => {
      if (window.GorgiasChat?.open) {
        window.GorgiasChat.open()
        return true
      }
      return false
    }

    let chatOpenAttempts = 0
    const openAvailableChat = () => {
      if (openShopifyChat() || openGorgiasChat() || chatOpenAttempts >= 12) return
      chatOpenAttempts += 1
      window.setTimeout(openAvailableChat, 150)
    }
    openAvailableChat()
  })

  window.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !drawer.hidden) closeDrawer()
  })

  window.addEventListener('resize', () => {
    if (!drawer.hidden) requestCartViewportHeightSync()
    if (activeCart) syncServicePromises(activeCart)
  })
  window.visualViewport?.addEventListener('resize', requestCartViewportHeightSync)
  window.visualViewport?.addEventListener('scroll', requestCartViewportHeightSync)

  fetchCart().catch(() => {})
})()

;(() => {
  const productRoot = document.querySelector('[data-product-root]')
  if (!productRoot) return

  const variantsScript = productRoot.querySelector('[data-product-json]')
  const variants = variantsScript ? JSON.parse(variantsScript.textContent || '[]') : []
  const stockScript = productRoot.querySelector('[data-product-stock-json]')
  const stockByVariant = stockScript ? JSON.parse(stockScript.textContent || '{}') : {}
  const twinScript = productRoot.querySelector('[data-product-twin-variants]')
  const twinVariants = twinScript ? JSON.parse(twinScript.textContent || '[]') : []
  const productForm = productRoot.querySelector('[data-product-form]')
  const productSubmit = productRoot.querySelector('[data-product-submit]')
  const productBuy = productRoot.querySelector('[data-product-buy]')
  const twinCard = productRoot.querySelector('[data-product-twin-card]')
  const choiceSubmit = productRoot.querySelector('[data-product-choice-submit]')
  const alternativeSubmit = productRoot.querySelector('[data-alternative-cart-form] button[type="submit"]')
  let choiceHideTimer = null
  let floatingVariantSyncTimer = null
  let requestFloatingSync = () => {}
  const floatingSubmit = productRoot.querySelector('[data-product-floating-submit]')
  const floatingSubmitText = productRoot.querySelector('[data-product-floating-submit-text]')
  const addToCartLabel = productForm?.dataset.productAddLabel || 'Add to cart'
  const preorderLabel = productForm?.dataset.productPreorderLabel || 'Pre order'
  const soldOutLabel = productForm?.dataset.productSoldOutLabel || 'Sold out'
  const preorderCopy = productForm?.dataset.productPreorderCopy || 'Due to high demand, these are now on pre order discount deal. These will be shipped on {date}. Secure yours now to take advantage of the pre order offer before the next batch arrives.'
  const preorderCopyIsHtml = productForm?.dataset.productPreorderCopyHtml === 'true'
  const preorderFallbackDate = productForm?.dataset.productPreorderFallbackDate || 'soon'
  const formatTemplate = (template, values = {}) => {
    return Object.entries(values).reduce((result, [key, value]) => {
      return result.split(`{${key}}`).join(value)
    }, template)
  }
  const moneyWithCurrencyFormatter = (amount) => {
    const currency = window.Shopify?.currency?.active || 'EUR'
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
      }).format(amount / 100)
    } catch (_error) {
      return `${(amount / 100).toFixed(2)} ${currency}`
    }
  }

  const parseDate = (value) => {
    if (!value) return null
    const date = new Date(`${value}T00:00:00`)
    return Number.isNaN(date.getTime()) ? null : date
  }

  const formatRestockDate = (date) => {
    if (!date) return preorderFallbackDate

    try {
      const month = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { month: 'short' }).format(date).replace(/\.$/, '')
      return `${month}. ${date.getDate()}`
    } catch (_error) {
      return `${date.getMonth() + 1}/${date.getDate()}`
    }
  }

  const selectedOptions = new Map()
  productRoot.querySelectorAll('[data-product-option]').forEach((group) => {
    const active = group.querySelector('[data-option-position].is-active')
    if (active) selectedOptions.set(active.dataset.optionPosition, active.dataset.optionValue)
  })

  const productGallery = productRoot.querySelector('[data-product-gallery]')
  const galleryVariantScript = productGallery?.querySelector('[data-product-gallery-variant-media]')
  let galleryMediaByVariant = {}

  if (galleryVariantScript) {
    try {
      galleryMediaByVariant = JSON.parse(galleryVariantScript.textContent || '{}')
    } catch (error) {
      galleryMediaByVariant = {}
    }
  }

  const applyGalleryFocalPoint = (image, focalPoint) => {
    if (!image) return
    if (focalPoint) {
      image.style.objectPosition = focalPoint
    } else {
      image.style.removeProperty('object-position')
    }
  }

  const updateGalleryImage = (variant) => {
    if (!productGallery || !variant) return

    const media = galleryMediaByVariant[String(variant.id)]
    if (!media?.src) return

    let featured = productGallery.querySelector('[data-product-gallery-featured]')
    if (featured) {
      if (featured.tagName !== 'IMG') {
        const image = document.createElement('img')
        image.setAttribute('data-product-gallery-featured', '')
        featured.replaceWith(image)
        featured = image
      }

      featured.src = media.src
      if (media.srcset) featured.srcset = media.srcset
      featured.alt = media.alt || ''
      if (media.mediaId) featured.dataset.productGalleryMediaId = String(media.mediaId)
      applyGalleryFocalPoint(featured, media.focalPoint)
    }

    productGallery.querySelectorAll('[data-product-gallery-thumb]').forEach((button) => {
      button.classList.toggle('is-active', String(button.dataset.productGalleryMediaId) === String(media.mediaId))
    })

    const mobile = productGallery.querySelector('[data-product-gallery-mobile]')
    const mobileImage = media.mediaId ? productGallery.querySelector(`[data-product-gallery-mobile] [data-product-gallery-media-id="${media.mediaId}"]`) : null
    if (mobile && mobileImage) {
      const images = Array.from(mobile.querySelectorAll('img'))
      const imageIndex = images.indexOf(mobileImage)
      if (imageIndex >= 0) {
        mobile.scrollTo({ left: imageIndex * mobile.clientWidth, behavior: 'smooth' })
        productGallery.querySelectorAll('[data-product-gallery-dot]').forEach((dot, dotIndex) => {
          if (dotIndex === imageIndex) {
            dot.setAttribute('aria-current', 'true')
          } else {
            dot.removeAttribute('aria-current')
          }
        })
      }
    } else if (mobile) {
      const firstMobileImage = mobile.querySelector('img')
      if (!firstMobileImage) return

      firstMobileImage.src = media.src
      if (media.srcset) firstMobileImage.srcset = media.srcset
      firstMobileImage.alt = media.alt || ''
      if (media.mediaId) firstMobileImage.dataset.productGalleryMediaId = String(media.mediaId)
      applyGalleryFocalPoint(firstMobileImage, media.focalPoint)
      mobile.scrollTo({ left: 0, behavior: 'auto' })
      productGallery.querySelectorAll('[data-product-gallery-dot]').forEach((dot, dotIndex) => {
        if (dotIndex === 0) {
          dot.setAttribute('aria-current', 'true')
        } else {
          dot.removeAttribute('aria-current')
        }
      })
    }
  }

  const updateSelectedLabels = (position, value) => {
    productRoot.querySelectorAll(`[data-selected-option-label="${position}"]`).forEach((label) => {
      label.textContent = value
    })
  }

  const matchingVariant = () => {
    if (!variants.length) return null

    return variants.find((variant) => {
      return [variant.option1, variant.option2, variant.option3].every((optionValue, index) => {
        if (!optionValue) return true
        const selected = selectedOptions.get(String(index + 1))
        return !selected || selected === optionValue
      })
    }) || variants[0]
  }

  const updateVariant = () => {
    const variant = matchingVariant()
    if (!variant) return

    productRoot.querySelectorAll('[data-variant-id]').forEach((input) => {
      input.value = variant.id
    })

    const price = productRoot.querySelector('[data-product-price]')
    const compare = productRoot.querySelector('[data-product-compare]')
    const saving = productRoot.querySelector('[data-product-saving]')
    const submit = productRoot.querySelector('[data-product-submit]')
    const submitText = productRoot.querySelector('[data-product-submit-text]')
    const preorderNote = productRoot.querySelector('[data-product-preorder-note]')
    const preorderNoteText = productRoot.querySelector('[data-product-preorder-note-text]')
    const stockStatus = productRoot.querySelector('[data-product-stock-status]')
    const stockStatusText = productRoot.querySelector('[data-product-stock-status-text]')

    if (price) price.textContent = moneyWithCurrencyFormatter(variant.price)

    if (compare) {
      compare.textContent = variant.compare_at_price && variant.compare_at_price > variant.price ? moneyWithCurrencyFormatter(variant.compare_at_price) : ''
      compare.hidden = !(variant.compare_at_price && variant.compare_at_price > variant.price)
    }

    if (saving) {
      const hasSaving = variant.compare_at_price && variant.compare_at_price > variant.price
      const percent = hasSaving ? Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) : 0
      const savingTemplate = saving.dataset.productSavingTemplate || 'Save {percent}%'
      saving.textContent = hasSaving ? formatTemplate(savingTemplate, { percent }) : ''
      saving.hidden = !hasSaving
    }

    const stockMeta = stockByVariant[String(variant.id)] || {}
    const isPreorder = variant.available && stockMeta.preorder === true
    const twinVariant = !(variant.available && stockMeta.preorderOverride === true) && stockMeta.physicalOutOfStock === true && /^\d+$/.test(variant.option1 || '')
      ? twinVariants.find((candidate) => String(candidate.sourceId) === String(variant.id) && candidate.size === variant.option1)
      : null

    if (stockStatus) {
      const label = !variant.available ? soldOutLabel : !isPreorder
        ? stockStatus.dataset.inStockLabel || 'Limited stock - ready to ship'
        : stockStatus.dataset.preorderLabel || 'Pre order'
      const timelineLabel = stockStatus.dataset.stockTimelineLabel || 'View delivery timeline.'
      const previousState = stockStatus.classList.contains('is-sold-out') ? 'sold-out' : stockStatus.classList.contains('is-preorder') ? 'preorder' : 'in-stock'
      const nextState = !variant.available ? 'sold-out' : isPreorder ? 'preorder' : 'in-stock'
      if (previousState !== nextState) {
        stockStatus.classList.remove('is-changing')
        window.requestAnimationFrame(() => {
          stockStatus.classList.add('is-changing')
        })
      }
      stockStatus.classList.toggle('is-in-stock', variant.available && !isPreorder)
      stockStatus.classList.toggle('is-sold-out', !variant.available)
      stockStatus.classList.toggle('is-preorder', isPreorder)
      stockStatus.setAttribute('aria-label', timelineLabel ? `${label}. ${timelineLabel}` : label)
      if (stockStatusText) stockStatusText.textContent = label
    }

    if (submit) {
      submit.disabled = !twinVariant && !variant.available
      submit.type = twinVariant ? 'button' : 'submit'
    }
    if (submitText) submitText.textContent = twinVariant
      ? variant.available ? twinCard?.dataset.twinChooseLabel || 'Choose an option' : twinCard?.dataset.twinViewAlternativeLabel || 'View available alternative'
      : isPreorder ? preorderLabel : (variant.available ? addToCartLabel : soldOutLabel)
    if (floatingSubmit) floatingSubmit.disabled = !twinVariant && !variant.available
    if (floatingSubmitText) floatingSubmitText.textContent = twinVariant
      ? variant.available ? twinCard?.dataset.twinChooseLabel || 'Choose an option' : twinCard?.dataset.twinViewAlternativeLabel || 'View available alternative'
      : isPreorder ? preorderLabel : (variant.available ? addToCartLabel : soldOutLabel)
    if (preorderNote) {
      const showNote = isPreorder && !twinVariant
      preorderNote.classList.toggle('is-hidden', !showNote)
      preorderNote.setAttribute('aria-hidden', showNote ? 'false' : 'true')
    }
    if (preorderNoteText) {
      preorderNoteText.hidden = !isPreorder || Boolean(twinVariant)
      const noticeRestockDate = parseDate(stockMeta.restockDate)
      const noticeToday = new Date()
      noticeToday.setHours(0, 0, 0, 0)
      const unknownRestock = !noticeRestockDate || noticeRestockDate < noticeToday
      const preorderNoteCopy = isPreorder && twinVariant ? '' : isPreorder && unknownRestock
        ? productRoot.querySelector('[data-product-shipping-timeline]')?.dataset.restockUnconfirmedLabel || preorderFallbackDate
        : isPreorder
        ? formatTemplate(preorderCopy, { date: formatRestockDate(parseDate(stockMeta.restockDate)) })
        : ''
      if (preorderCopyIsHtml) {
        preorderNoteText.innerHTML = preorderNoteCopy
      } else {
        preorderNoteText.textContent = preorderNoteCopy
      }
    }
    if (twinCard) {
      const twinForm = twinCard.querySelector('[data-alternative-cart-form]')
      const twinIdInput = twinCard.querySelector('[data-product-twin-id]')
      const twinAddButton = twinForm?.querySelector('button[type="submit"]')
      if (twinIdInput) twinIdInput.value = twinVariant?.id || ''
      if (twinAddButton) twinAddButton.disabled = !twinVariant
      if (twinVariant) {
        const waitChoice = twinCard.querySelector('[data-product-choice-wait]')
        const choiceSubheading = twinCard.querySelector('[data-product-choice-heading-sub]')
        if (waitChoice) waitChoice.hidden = !variant.available
        if (choiceSubheading) choiceSubheading.textContent = variant.available
          ? twinCard.dataset.twinChoiceSubheading || 'Choose what works for you:'
          : twinCard.dataset.twinAlternativeSubheading || 'This alternative ships now.'
        const twinTitle = twinCard.querySelector('[data-product-twin-title]')
        const twinOptions = twinCard.querySelector('[data-product-twin-options]')
        const twinPrice = twinCard.querySelector('[data-product-twin-price]')
        const twinLink = twinCard.querySelector('[data-product-twin-link]')
        const sourceOptions = twinCard.querySelector('[data-product-choice-options]')
        const sourcePrice = twinCard.querySelector('[data-product-choice-price]')
        const sourceImage = twinCard.querySelector('[data-product-choice-image]')
        const restockDate = parseDate(stockMeta.restockDate)
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        const hasFutureRestock = restockDate && restockDate >= today
        if (twinTitle) twinTitle.textContent = twinVariant.title
        if (twinOptions) twinOptions.textContent = [
          `${twinCard.dataset.twinSize || 'Size'} ${twinVariant.size}`,
          twinVariant.finish,
        ].filter(Boolean).join(' · ')
        if (twinPrice) twinPrice.textContent = twinVariant.price
        if (twinLink) twinLink.href = twinVariant.url
        if (sourceOptions) sourceOptions.textContent = [
          `${twinCard.dataset.twinSize || 'Size'} ${variant.option1}`,
          variant.option2,
        ].filter(Boolean).join(' · ')
        if (sourcePrice) sourcePrice.textContent = twinVariant.sourcePrice
        const sourceMedia = galleryMediaByVariant[String(variant.id)]
        if (sourceImage) sourceImage.src = sourceMedia?.src?.replace(/([?&])width=\d+/, '$1width=160') || sourceImage.dataset.defaultSrc || sourceImage.src
        if (choiceSubmit) {
          choiceSubmit.disabled = !variant.available
          choiceSubmit.dataset.productChoiceAvailable = variant.available ? 'true' : 'false'
          choiceSubmit.textContent = isPreorder ? preorderLabel : (variant.available ? addToCartLabel : soldOutLabel)
        }
        const waitBadge = twinCard.querySelector('[data-product-choice-wait-badge]')
        if (waitBadge) waitBadge.textContent = variant.available && hasFutureRestock
          ? formatTemplate(twinCard.dataset.twinWaitDate || 'Pre-order · Expected to ship on {date}', { date: formatRestockDate(restockDate) })
          : variant.available ? twinCard.dataset.twinWaitLabel || 'Pre-order'
          : twinCard.dataset.twinSoldOutLabel || 'Sold out'
        const twinImage = twinCard.querySelector('[data-product-twin-image]')
        if (twinImage && twinImage.src !== twinVariant.image) twinImage.src = twinVariant.image
      }
      window.clearTimeout(choiceHideTimer)
      if (twinVariant) {
        if (twinCard.hidden) {
          twinCard.hidden = false
          twinCard.offsetHeight
        }
        productBuy?.classList.add('is-choice-open')
        twinCard.setAttribute('aria-hidden', 'false')
      } else {
        twinCard.setAttribute('aria-hidden', 'true')
        if (productBuy?.classList.contains('is-choice-open')) {
          productBuy.classList.remove('is-choice-open')
          choiceHideTimer = window.setTimeout(() => {
            if (!productBuy.classList.contains('is-choice-open')) twinCard.hidden = true
          }, 300)
        } else {
          twinCard.hidden = true
        }
      }
    }
    updateGalleryImage(variant)
    updateShippingTimeline(variant, isPreorder)
    requestFloatingSync()
    window.clearTimeout(floatingVariantSyncTimer)
    floatingVariantSyncTimer = window.setTimeout(requestFloatingSync, 300)
  }

  const updateShippingTimeline = (variant = matchingVariant(), isPreorderOverride) => {
    const timeline = productRoot.querySelector('[data-product-shipping-timeline]')
    if (!timeline) return

    const formatDate = (date) => {
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${day}-${month}`
    }
    const addDays = (date, days) => {
      const nextDate = new Date(date)
      nextDate.setDate(nextDate.getDate() + days)
      return nextDate
    }
    const now = new Date()
    const stockMeta = variant ? stockByVariant[String(variant.id)] || {} : {}
    const isPreorder = typeof isPreorderOverride === 'boolean'
      ? isPreorderOverride
      : (variant?.available && stockMeta.preorder === true)
    const restockDate = isPreorder ? parseDate(stockMeta.restockDate) : null
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const unavailable = !variant?.available
    const restockUnconfirmed = isPreorder && (!restockDate || restockDate < today)
    const shippingStatus = productRoot.querySelector('[data-product-shipping-status]')
    timeline.hidden = unavailable || restockUnconfirmed
    if (shippingStatus) {
      shippingStatus.hidden = !timeline.hidden
      shippingStatus.textContent = unavailable
        ? timeline.dataset.unavailableLabel
        : restockUnconfirmed ? timeline.dataset.restockUnconfirmedLabel : ''
    }
    if (timeline.hidden) {
      timeline.querySelectorAll('[data-shipping-date]').forEach((element) => { element.textContent = '' })
      return
    }
    const shipDate = restockDate || addDays(now, now.getHours() >= 23 ? 1 : 0)
    const deliveryStart = addDays(shipDate, 4)
    const deliveryEnd = addDays(shipDate, 6)

    const order = timeline.querySelector('[data-shipping-date="order"]')
    const ship = timeline.querySelector('[data-shipping-date="ship"]')
    const delivery = timeline.querySelector('[data-shipping-date="delivery"]')

    const setTimelineDate = (element, value) => {
      if (!element || element.textContent === value) return
      element.textContent = value
      element.classList.remove('is-changing')
      window.requestAnimationFrame(() => {
        element.classList.add('is-changing')
      })
    }

    setTimelineDate(order, formatDate(now))
    setTimelineDate(ship, formatDate(shipDate))
    setTimelineDate(delivery, `${formatDate(deliveryStart)} - ${formatDate(deliveryEnd)}`)
  }

  productRoot.addEventListener('click', (event) => {
    const optionButton = event.target.closest('[data-option-position]')
    const colorChoice = event.target.closest('[data-product-color-choice]')
    const minus = event.target.closest('[data-product-quantity-minus]')
    const plus = event.target.closest('[data-product-quantity-plus]')
    const sizeGuide = event.target.closest('[data-size-guide-open]')
    const stockStatus = event.target.closest('[data-product-stock-status]')
    const floatingSubmitButton = event.target.closest('[data-product-floating-submit]')

    if (event.target.closest('[data-product-submit]') && productSubmit?.type === 'button' && twinCard && !twinCard.hidden) {
      event.preventDefault()
      window.clearTimeout(choiceHideTimer)
      productBuy?.classList.add('is-choice-open')
      twinCard.setAttribute('aria-hidden', 'false')
      return
    }

    if (floatingSubmitButton) {
      event.preventDefault()
      if (floatingSubmitButton.disabled || productSubmit?.disabled) return
      if (productSubmit?.type === 'button' && twinCard && !twinCard.hidden) {
        window.clearTimeout(choiceHideTimer)
        productBuy?.classList.add('is-choice-open')
        twinCard.setAttribute('aria-hidden', 'false')
        twinCard.scrollIntoView({ behavior: 'smooth', block: 'center' })
        return
      }
      if (productForm?.requestSubmit) {
        productForm.dataset.productFloatingSubmitRequested = 'true'
        productForm.requestSubmit(productSubmit || undefined)
      } else {
        productForm.dataset.productFloatingSubmitRequested = 'true'
        productSubmit?.click()
      }
      return
    }

    if (colorChoice) {
      const selector = colorChoice.closest('[data-product-color-selector]')
      const value = colorChoice.dataset.productColorChoice
      selector?.querySelectorAll('[data-product-color-choice]').forEach((button) => {
        const active = button === colorChoice
        button.classList.toggle('is-active', active)
        button.setAttribute('aria-pressed', active ? 'true' : 'false')
      })
      selector?.querySelectorAll('[data-product-color-label]').forEach((label) => {
        label.textContent = value
      })
    }

    if (optionButton) {
      const position = optionButton.dataset.optionPosition
      const value = optionButton.dataset.optionValue
      selectedOptions.set(position, value)
      optionButton.closest('.astari-product-option__values')?.querySelectorAll('[data-option-position]').forEach((button) => {
        const active = button === optionButton
        button.classList.toggle('is-active', active)
        button.setAttribute('aria-pressed', active ? 'true' : 'false')
      })
      updateSelectedLabels(position, value)
      updateVariant()
    }

    if (minus || plus) {
      event.preventDefault()
      const control = minus || plus
      const input = control.closest('.astari-product-quantity')?.querySelector('[data-product-quantity]')
      if (!input) return
      const min = Number(input.getAttribute('min') || 1)
      const current = Math.max(min, Number(input.value || min))
      input.value = String(plus ? current + 1 : Math.max(min, current - 1))
      input.dispatchEvent(new Event('change', { bubbles: true }))
    }

    if (sizeGuide) {
      event.preventDefault()
      const target = document.getElementById('product-size-guide')
      const sizeDetail = document.querySelector('[data-size-guide-detail]')
      const scrollTarget = sizeDetail || target
      if (sizeDetail && !sizeDetail.open) {
        sizeDetail.querySelector('summary')?.click()
      }
      if (scrollTarget) window.setTimeout(() => {
        scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }, 0)
      window.history.replaceState(null, '', '#product-size-guide')
    }

    if (stockStatus) {
      event.preventDefault()
      const selector = stockStatus.dataset.productStockTarget || '#product-shipping-timeline'
      const target = productRoot.querySelector(selector) || document.querySelector(selector) || productRoot.querySelector('[data-product-shipping-timeline]')
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  })

  if (floatingSubmit) {
    const floatingMedia = window.matchMedia('(max-width: 1023px)')
    const footer = document.querySelector('.astari-footer')
    let floatingFrame = null
    let floatingDockHandoffTimeout = null
    let lastFloatingScrollY = window.scrollY

    const syncFloatingViewportOffset = () => {
      const viewport = window.visualViewport
      const visualBottomOffset = viewport ? Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop) : 0
      const safariToolbarClearance = window.scrollY > 16 ? Math.min(56, Math.round(visualBottomOffset * 0.72)) : 0
      floatingSubmit.style.setProperty('--astari-floating-atc-visual-bottom-offset', `${safariToolbarClearance}px`)
    }

    const clearFloatingDockHandoff = () => {
      if (floatingDockHandoffTimeout) {
        window.clearTimeout(floatingDockHandoffTimeout)
        floatingDockHandoffTimeout = null
      }
      floatingSubmit.classList.remove('is-entering-from-bottom')
    }

    const syncFloatingSubmit = () => {
      floatingFrame = null
      syncFloatingViewportOffset()
      const currentScrollY = window.scrollY
      const isScrollingDown = currentScrollY > lastFloatingScrollY + 1
      const floatingAddIsPending = document.body.classList.contains('astari-product-floating-adding') && floatingSubmit.classList.contains('is-loading')
      if (floatingAddIsPending) {
        clearFloatingDockHandoff()
        floatingSubmit.classList.remove('is-docked')
        floatingSubmit.classList.add('is-visible')
        floatingSubmit.setAttribute('aria-hidden', 'false')
        lastFloatingScrollY = currentScrollY
        return
      }
      const choiceIsOpen = twinCard && !twinCard.hidden && productBuy?.classList.contains('is-choice-open')
      const activeSubmit = choiceIsOpen
        ? (choiceSubmit?.closest('[data-product-choice-wait]')?.hidden ? alternativeSubmit : choiceSubmit)
        : productSubmit
      const submitRect = activeSubmit?.getBoundingClientRect()
      const footerRect = footer?.getBoundingClientRect()
      const footerIsVisible = Boolean(footerRect) && footerRect.top <= window.innerHeight
      const cartIsActive = document.body.classList.contains('astari-cart-open') || document.body.classList.contains('astari-cart-adding')
      const floatingIsSuppressed = floatingSubmit.classList.contains('is-suppressed')
      const submitIsVisible = Boolean(submitRect) && submitRect.top < window.innerHeight && submitRect.bottom > 0
      const wasDocked = floatingSubmit.classList.contains('is-docked')
      const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize) || 16
      const floatingBottomOffset = parseFloat(window.getComputedStyle(floatingSubmit).bottom) || Math.max(1.333 * rootFontSize, 1 * rootFontSize)
      const floatingHeight = floatingSubmit.offsetHeight || submitRect?.height || 56
      const floatingRestingTop = window.innerHeight - floatingBottomOffset - floatingHeight
      const dockThreshold = floatingRestingTop + (wasDocked ? 4 : 0)
      const submitHasReachedFloatingPosition = submitIsVisible && submitRect.top <= dockThreshold
      const submitHasPassedViewport = Boolean(submitRect) && submitRect.bottom <= 0
      const submitIsBelowFloatingPosition = Boolean(submitRect) && submitRect.top > dockThreshold
      const shouldDock = floatingMedia.matches && submitHasReachedFloatingPosition && !cartIsActive && !floatingIsSuppressed
      const shouldFloat = floatingMedia.matches && (submitIsBelowFloatingPosition || submitHasPassedViewport) && !footerIsVisible && !cartIsActive && !floatingIsSuppressed
      const shouldShow = shouldFloat
      const shouldAnimateFromDock = wasDocked && shouldFloat && isScrollingDown

      floatingSubmit.classList.toggle('is-docked', shouldDock)
      let floatingIsAriaVisible = shouldShow
      if (shouldAnimateFromDock) {
        if (!floatingDockHandoffTimeout) {
          floatingSubmit.classList.remove('is-visible')
          floatingSubmit.classList.add('is-entering-from-bottom')
          floatingSubmit.getBoundingClientRect()
          floatingDockHandoffTimeout = window.setTimeout(() => {
            floatingDockHandoffTimeout = null
            if (
              floatingSubmit.classList.contains('is-docked') ||
              floatingSubmit.classList.contains('is-suppressed') ||
              document.body.classList.contains('astari-cart-open') ||
              document.body.classList.contains('astari-cart-adding')
            ) {
              floatingSubmit.classList.remove('is-entering-from-bottom')
              return
            }
            floatingSubmit.classList.remove('is-entering-from-bottom')
            floatingSubmit.classList.add('is-visible')
            floatingSubmit.setAttribute('aria-hidden', 'false')
          }, 80)
        }
        floatingIsAriaVisible = false
      } else if (floatingDockHandoffTimeout && shouldFloat) {
        floatingSubmit.classList.remove('is-visible')
        floatingSubmit.classList.add('is-entering-from-bottom')
        floatingIsAriaVisible = false
      } else {
        clearFloatingDockHandoff()
        floatingSubmit.classList.toggle('is-visible', shouldShow)
      }
      floatingSubmit.setAttribute('aria-hidden', floatingIsAriaVisible ? 'false' : 'true')
      lastFloatingScrollY = currentScrollY
    }

    requestFloatingSync = () => {
      if (floatingFrame) return
      floatingFrame = window.requestAnimationFrame(syncFloatingSubmit)
    }

    window.addEventListener('scroll', requestFloatingSync, { passive: true })
    window.addEventListener('resize', requestFloatingSync)
    window.visualViewport?.addEventListener('scroll', requestFloatingSync, { passive: true })
    window.visualViewport?.addEventListener('resize', requestFloatingSync)
    if (floatingMedia.addEventListener) {
      floatingMedia.addEventListener('change', requestFloatingSync)
    } else if (floatingMedia.addListener) {
      floatingMedia.addListener(requestFloatingSync)
    }
    requestFloatingSync()
  }

	  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mobile = gallery.querySelector('[data-product-gallery-mobile]')
    const dots = gallery.querySelectorAll('[data-product-gallery-dot]')
    const mobileImages = Array.from(mobile?.querySelectorAll('.astari-product-gallery__mobile-track > img, .astari-product-gallery__mobile-track > video') || [])
    const mobileAutoplay = window.matchMedia('(max-width: 760px)')
    let mobileAutoplayTimer = null
    let mobileAutoplayPaused = false
    let mobileAutoplayScrollLeft = 0
    let mobileAutoplayProgrammatic = false
    let mobileDotFrame = null
    let mobileDotActivityTimer = null
    let mobileUserActivityTimer = null
    let mobileUserActive = false
    let mobileBoundarySwipeStart = null

    const showMobileGalleryDots = () => {
      gallery.classList.add('is-mobile-gallery-moving')
      window.clearTimeout(mobileDotActivityTimer)
      mobileDotActivityTimer = window.setTimeout(() => {
        gallery.classList.remove('is-mobile-gallery-moving')
      }, 1000)
    }

    const markMobileGalleryUserActive = () => {
      mobileUserActive = true
      showMobileGalleryDots()
      window.clearTimeout(mobileUserActivityTimer)
      mobileUserActivityTimer = window.setTimeout(() => {
        mobileUserActive = false
      }, 1200)
    }

    const setMobileGalleryDot = (index) => {
      const activeIndex = Math.max(0, Math.min(index, dots.length - 1))
      dots.forEach((dot, dotIndex) => {
        if (dotIndex === activeIndex) {
          dot.setAttribute('aria-current', 'true')
        } else {
          dot.removeAttribute('aria-current')
        }
      })
    }

    const getMobileGalleryIndex = () => {
      if (!mobile || !mobileImages.length) return 0

      const itemWidth = mobileImages[0]?.getBoundingClientRect().width || mobile.clientWidth || 1
      return Math.max(0, Math.min(Math.round(mobile.scrollLeft / itemWidth), mobileImages.length - 1))
    }

    const getMobileGalleryScrollLeft = (index) => {
      const targetIndex = Math.max(0, Math.min(index, mobileImages.length - 1))
      return mobileImages[targetIndex]?.offsetLeft ?? (targetIndex * (mobile?.clientWidth || 0))
    }

    const syncMobileGalleryVideos = () => {
      const activeIndex = getMobileGalleryIndex()
      mobileImages.forEach((item, itemIndex) => {
        if (item.tagName !== 'VIDEO') return

        if (itemIndex === activeIndex) {
          playLazyVideo(item)
        } else {
          pauseLazyVideo(item)
        }
      })
    }

    const scrollMobileGalleryToIndex = (index, behavior = 'smooth', syncDot = true) => {
      if (!mobile || !mobileImages.length) return
      const targetIndex = Math.max(0, Math.min(index, mobileImages.length - 1))
      if (syncDot) setMobileGalleryDot(targetIndex)
      mobile.scrollTo({ left: getMobileGalleryScrollLeft(targetIndex), behavior })
      window.requestAnimationFrame(syncMobileGalleryVideos)
    }

    const syncMobileGalleryDots = () => {
      if (!dots.length) return
      setMobileGalleryDot(getMobileGalleryIndex())
    }

    const scheduleMobileGalleryDotSync = () => {
      if (mobileDotFrame) return
      mobileDotFrame = window.requestAnimationFrame(() => {
        mobileDotFrame = null
        syncMobileGalleryDots()
        syncMobileGalleryVideos()
      })
    }

    const stopMobileAutoplay = () => {
      if (mobileAutoplayTimer) window.clearInterval(mobileAutoplayTimer)
      mobileAutoplayTimer = null
    }

    const startMobileAutoplay = () => {
      if (!mobile || mobileImages.length < 2 || !mobileAutoplay.matches || mobileAutoplayPaused || mobileAutoplayTimer) return

      mobileAutoplayTimer = window.setInterval(() => {
        if (!mobile.isConnected || !mobileAutoplay.matches || mobileAutoplayPaused) {
          stopMobileAutoplay()
          return
        }

        const currentIndex = getMobileGalleryIndex()
        const nextIndex = (currentIndex + 1) % mobileImages.length
        mobileAutoplayProgrammatic = true
        mobileAutoplayScrollLeft = getMobileGalleryScrollLeft(nextIndex)
        scrollMobileGalleryToIndex(nextIndex, 'smooth', false)
        window.setTimeout(() => {
          mobileAutoplayProgrammatic = false
        }, 900)
      }, 5000)
    }

    const pauseMobileAutoplay = () => {
      mobileAutoplayPaused = true
      stopMobileAutoplay()
    }

    const resumeMobileAutoplay = () => {
      if (!mobileAutoplay.matches || !mobileAutoplayPaused) return
      mobileAutoplayPaused = false
      startMobileAutoplay()
    }

    gallery.addEventListener('click', (event) => {
      const dot = event.target.closest('[data-product-gallery-dot]')

      if (dot && mobile) {
        pauseMobileAutoplay()
        markMobileGalleryUserActive()
        const dotIndex = Number(dot.dataset.productGalleryDot)
        scrollMobileGalleryToIndex(dotIndex)
      }
    })

    mobile?.addEventListener('scroll', () => {
      if (mobileUserActive) showMobileGalleryDots()
      scheduleMobileGalleryDotSync()

      if (
        mobileAutoplayTimer &&
        mobileAutoplayProgrammatic &&
        Math.abs(mobile.scrollLeft - mobileAutoplayScrollLeft) <= 4
      ) {
        mobileAutoplayProgrammatic = false
      }
    }, { passive: true })
    mobile?.addEventListener('scrollend', () => {
      syncMobileGalleryDots()
      syncMobileGalleryVideos()
    }, { passive: true })

    mobile?.addEventListener('pointerdown', () => {
      pauseMobileAutoplay()
      markMobileGalleryUserActive()
    }, { passive: true })
    const recordMobileBoundarySwipeStart = (touch) => {
      if (!mobile || mobileImages.length < 2 || !touch) return
      mobileBoundarySwipeStart = {
        x: touch.clientX,
        y: touch.clientY,
        index: getMobileGalleryIndex()
      }
    }

    const wrapMobileBoundarySwipe = (touch) => {
      if (!mobile || !mobileBoundarySwipeStart || mobileImages.length < 2 || !touch) {
        mobileBoundarySwipeStart = null
        return
      }

      const deltaX = touch.clientX - mobileBoundarySwipeStart.x
      const deltaY = touch.clientY - mobileBoundarySwipeStart.y
      const horizontalDistance = Math.abs(deltaX)
      const lastIndex = mobileImages.length - 1
      const targetIndex = deltaX < 0 && mobileBoundarySwipeStart.index === lastIndex
        ? 0
        : deltaX > 0 && mobileBoundarySwipeStart.index === 0
          ? lastIndex
          : null

      mobileBoundarySwipeStart = null

      if (targetIndex === null || horizontalDistance < 45 || horizontalDistance < Math.abs(deltaY) * 1.2) return

      markMobileGalleryUserActive()
      window.requestAnimationFrame(() => {
        scrollMobileGalleryToIndex(targetIndex)
      })
    }

    mobile?.addEventListener('touchstart', (event) => {
      pauseMobileAutoplay()
      markMobileGalleryUserActive()
      recordMobileBoundarySwipeStart(event.touches?.[0])
    }, { passive: true })
    mobile?.addEventListener('touchend', (event) => {
      wrapMobileBoundarySwipe(event.changedTouches?.[0])
    }, { passive: true })
    mobile?.addEventListener('touchcancel', () => {
      mobileBoundarySwipeStart = null
    }, { passive: true })
    mobile?.addEventListener('wheel', (event) => {
      if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
        pauseMobileAutoplay()
        markMobileGalleryUserActive()
      }
    }, { passive: true })

    window.addEventListener('scroll', resumeMobileAutoplay, { passive: true })
    mobileAutoplay.addEventListener('change', () => {
      if (mobileAutoplay.matches) {
        startMobileAutoplay()
      } else {
        stopMobileAutoplay()
      }
    })
    window.addEventListener('pagehide', stopMobileAutoplay, { once: true })
    syncMobileGalleryDots()
    syncMobileGalleryVideos()
	    startMobileAutoplay()
	  })

  const initVisibleGalleryVideos = () => {
  const visibleLazyVideos = document.querySelectorAll('[data-lazy-video][data-lazy-video-mode="visible"]')
  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target
        if (entry.isIntersecting) {
          playLazyVideo(video)
        } else {
          pauseLazyVideo(video)
        }
      })
    }, { rootMargin: '200px 0px', threshold: 0.25 })

    visibleLazyVideos.forEach((video) => videoObserver.observe(video))
  } else {
    visibleLazyVideos.forEach(loadLazyVideo)
  }
  }
  if (document.readyState === 'complete') {
    window.setTimeout(initVisibleGalleryVideos, 1000)
  } else {
    window.addEventListener('load', () => window.setTimeout(initVisibleGalleryVideos, 1000), { once: true })
  }

  document.querySelectorAll('[data-product-rail]').forEach((rail) => {
    if (rail.dataset.productRailFadeReady === 'true') return

    rail.dataset.productRailFadeReady = 'true'
    rail.addEventListener('scroll', () => {
      showProductRailControls(rail.closest('.astari-product-collection__stage'))
    }, { passive: true })
  })

  updateShippingTimeline()
  updateVariant()
})()

;(() => {
  const footerNewsletter = document.querySelector('.astari-footer__newsletter')
  if (!footerNewsletter) return

  const activeClass = 'astari-footer-captcha-active'
  const managedClass = 'astari-footer-captcha-managed'
  const field = footerNewsletter.querySelector('.astari-footer__newsletter-field')
  const emailInput = footerNewsletter.querySelector('input[type="email"]')
  const submitButton = footerNewsletter.querySelector('button[type="submit"]')
  const status = footerNewsletter.querySelector('[data-footer-newsletter-status]')
  const newsletterSubscribedLabel = status?.dataset.newsletterSubscribedLabel || 'Subscribed'
  let captchaArmed = false
  let syncTimer = null
  let nativeSubmitRequested = false

  const syncCaptchaPosition = () => {
    if (!field) return

    const formRect = footerNewsletter.getBoundingClientRect()
    const renderedRect = field.getBoundingClientRect()
    const rect = {
      left: formRect.left + field.offsetLeft,
      top: formRect.top + field.offsetTop,
      height: renderedRect.height,
    }
    const badgeSize = 44
    const gap = 12
    const desktopLeft = Math.min(window.innerWidth - badgeSize - 12, formRect.right - badgeSize - 12)
    const desktopTop = rect.top + (rect.height - badgeSize) / 2
    const mobileLeft = desktopLeft
    const mobileTop = desktopTop
    const challengeWidth = 300
    const challengeHeight = 150
    const challengeLeft = Math.max(12, rect.left - challengeWidth - gap)
    const challengeTop = Math.max(12, rect.top + (rect.height - challengeHeight) / 2)
    const mobileChallengeLeft = Math.max(12, Math.min(rect.left, window.innerWidth - challengeWidth - 12))
    const mobileChallengeTop = Math.max(12, rect.top - challengeHeight - gap)

    document.documentElement.style.setProperty('--astari-footer-captcha-left', `${desktopLeft}px`)
    document.documentElement.style.setProperty('--astari-footer-captcha-top', `${desktopTop}px`)
    document.documentElement.style.setProperty('--astari-footer-captcha-mobile-left', `${mobileLeft}px`)
    document.documentElement.style.setProperty('--astari-footer-captcha-mobile-top', `${mobileTop}px`)
    document.documentElement.style.setProperty('--astari-footer-captcha-challenge-left', `${challengeLeft}px`)
    document.documentElement.style.setProperty('--astari-footer-captcha-challenge-top', `${challengeTop}px`)
    document.documentElement.style.setProperty('--astari-footer-captcha-mobile-challenge-left', `${mobileChallengeLeft}px`)
    document.documentElement.style.setProperty('--astari-footer-captcha-mobile-challenge-top', `${mobileChallengeTop}px`)
  }

  const setActive = () => {
    document.documentElement.classList.add(managedClass)
    document.documentElement.classList.add(activeClass)
    window.requestAnimationFrame(syncCaptchaPosition)
  }

  const clearActive = () => {
    document.documentElement.classList.remove(activeClass)
  }

  const hasVisibleChallenge = () => {
    return Array.from(document.querySelectorAll('iframe[src*="hcaptcha"][src*="frame=challenge"]')).some((iframe) => {
      const rect = iframe.getBoundingClientRect()
      const style = window.getComputedStyle(iframe)
      return rect.width > 20 && rect.height > 20 && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0'
    })
  }

  const updateCaptchaState = () => {
    if (captchaArmed && hasVisibleChallenge()) {
      setActive()
    } else {
      clearActive()
    }
  }

  const scheduleUpdate = () => {
    if (syncTimer) window.clearTimeout(syncTimer)
    syncTimer = window.setTimeout(updateCaptchaState, 80)
  }

  const armCaptcha = () => {
    captchaArmed = true
    document.documentElement.classList.add(managedClass)
    scheduleUpdate()
    window.setTimeout(updateCaptchaState, 350)
    window.setTimeout(updateCaptchaState, 900)
  }

  const showNewsletterStatus = (message, state = 'success') => {
    if (!status) return
    status.textContent = message
    status.dataset.state = state
    status.hidden = false
  }

  const hideNewsletterStatus = () => {
    if (!status) return
    status.textContent = ''
    status.removeAttribute('data-state')
    status.hidden = true
  }

  const didNewsletterSubmitSucceed = async (response) => {
    const responseUrl = new URL(response.url || window.location.href, window.location.href)
    if (responseUrl.searchParams.get('customer_posted') === 'true') return true

    const html = await response.text()
    if (html.includes('customer_posted=true')) return true

    const doc = new DOMParser().parseFromString(html, 'text/html')
    const form = doc.querySelector('#contact_form')
    return Boolean(form?.querySelector('.form-status, [data-form-status]'))
  }

  const submitNewsletterWithoutReload = async (event) => {
    if (nativeSubmitRequested) return
    if (!footerNewsletter.checkValidity()) return

    event.preventDefault()
    armCaptcha()
    hideNewsletterStatus()
    footerNewsletter.setAttribute('aria-busy', 'true')
    if (submitButton) submitButton.disabled = true

    try {
      const response = await fetch(footerNewsletter.action, {
        method: 'POST',
        body: new FormData(footerNewsletter),
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest',
        },
      })

      if (!response.ok || !(await didNewsletterSubmitSucceed(response))) {
        nativeSubmitRequested = true
        footerNewsletter.requestSubmit()
        return
      }

      showNewsletterStatus(newsletterSubscribedLabel)
      if (emailInput) emailInput.value = ''
    } catch (error) {
      nativeSubmitRequested = true
      footerNewsletter.requestSubmit()
    } finally {
      footerNewsletter.removeAttribute('aria-busy')
      if (submitButton && !nativeSubmitRequested) submitButton.disabled = false
    }
  }

  footerNewsletter.addEventListener('focusin', armCaptcha)
  footerNewsletter.addEventListener('pointerdown', armCaptcha)
  footerNewsletter.addEventListener('submit', armCaptcha)
  footerNewsletter.addEventListener('submit', submitNewsletterWithoutReload)
  emailInput?.addEventListener('input', hideNewsletterStatus)
  document.addEventListener('pointerdown', (event) => {
    if (footerNewsletter.contains(event.target)) return
    if (event.target instanceof Element && event.target.closest('#shop-hcaptcha-badge-container')) return
    if (!hasVisibleChallenge()) {
      captchaArmed = false
      clearActive()
    }
  }, { capture: true })
  window.addEventListener('resize', () => {
    if (document.documentElement.classList.contains(activeClass)) syncCaptchaPosition()
  })
  window.addEventListener('scroll', () => {
    if (document.documentElement.classList.contains(activeClass)) syncCaptchaPosition()
  }, { passive: true })
  const observeCaptchaChanges = () => {
    if (!document.body) return false

    new MutationObserver(scheduleUpdate).observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
    })
    return true
  }

  if (!observeCaptchaChanges()) {
    document.addEventListener('DOMContentLoaded', () => {
      observeCaptchaChanges()
      scheduleUpdate()
    }, { once: true })
  }
  document.documentElement.classList.add(managedClass)
})()

;(() => {
  const banner = document.querySelector('[data-cookie-consent]')
  if (!banner) return

  const acceptButton = banner.querySelector('[data-cookie-consent-accept]')
  const declineButton = banner.querySelector('[data-cookie-consent-decline]')
  const storageKey = 'astari_cookie_consent_choice'

  const hideBanner = () => {
    banner.hidden = true
  }

  const showBanner = () => {
    banner.hidden = false
  }

  const loadCustomerPrivacy = (callback, attempts = 0) => {
    if (window.Shopify?.customerPrivacy) {
      callback(window.Shopify.customerPrivacy)
      return
    }

    if (!window.Shopify?.loadFeatures) {
      if (attempts < 20) {
        window.setTimeout(() => loadCustomerPrivacy(callback, attempts + 1), 150)
      } else {
        callback(null)
      }
      return
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (error) => {
        callback(window.Shopify?.customerPrivacy || null)
      }
    )
  }

  const platformChoice = privacy => {
    try {
      const choice = privacy?.currentVisitorConsent().marketing
      return choice === 'yes' || choice === 'no' ? choice : null
    } catch (_error) {
      return null
    }
  }
  const consentStatus = value => {
    document.documentElement.dataset.astariConsentPersistence = value
    document.dispatchEvent(new CustomEvent('astari:consent-status'))
  }

  const storeChoice = (choice) => {
    try {
      window.localStorage.setItem(storageKey, choice)
    } catch (_error) {}
  }

  const setConsent = (choice) => {
    const accepted = choice === 'accepted'

    loadCustomerPrivacy((privacy) => {
      if (!privacy) {
        consentStatus('api-unavailable')
        showBanner()
        return
      }

      const consent = {
        analytics: accepted,
        marketing: accepted,
        preferences: accepted,
        sale_of_data: accepted,
      }

      try {
        privacy.setTrackingConsent(consent, result => {
          if (result?.error || platformChoice(privacy) !== (accepted ? 'yes' : 'no')) {
            consentStatus('save-unconfirmed')
            showBanner()
            return
          }
          storeChoice(choice)
          consentStatus('saved')
          hideBanner()
        })
      } catch (_error) {
        consentStatus('save-failed')
        showBanner()
      }
    })
  }

  loadCustomerPrivacy(privacy => {
    if (platformChoice(privacy)) {
      consentStatus('platform-choice-present')
      hideBanner()
      return
    }

    consentStatus(privacy ? 'choice-required' : 'api-unavailable')
    showBanner()
  })

  document.addEventListener('click', event => {
    if (!event.target.closest?.('[data-cookie-consent-open]')) return
    showBanner()
    acceptButton?.focus?.()
  })

  acceptButton?.addEventListener('click', () => setConsent('accepted'))
  declineButton?.addEventListener('click', () => setConsent('declined'))
})()
